/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title CoreService
 * @version 1.0.0
 *
 * Houses supporting services
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  readiness = {
    /**
     * No description
     *
     * @name ReadinessList
     * @request GET:/readiness
     */
    readinessList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/readiness`,
        method: "GET",
        ...params,
      }),
  };
  core = {
    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsList
     * @request GET:/core/background-jobs
     * @secure
     */
    backgroundJobsList: (
      query?: {
        createdAfter?: string;
        createdBefore?: string;
        jobType?: "imports" | "giscopy" | "doc-gen" | "gis-spatial-reference-update";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: any;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: any;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
          user: {
            personId: number;
            firstName: string;
            lastName: string;
          } | null;
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/background-jobs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsCreate
     * @request POST:/core/background-jobs
     * @secure
     */
    backgroundJobsCreate: (
      data: {
        name: string;
        recordsTotal: number;
        jobType:
          | "user-import-standard"
          | "user-import-custom"
          | "location-import-standard"
          | "location-import-custom"
          | "permit-import-standard"
          | "permit-import-custom"
          | "crm-export"
          | "ce-export"
          | "permit-attachments-import-standard"
          | "permit-attachments-import-custom"
          | "crm-request-import-standard"
          | "crm-request-import-custom"
          | "crm-attachments-import-standard"
          | "crm-attachments-import-custom"
          | "crm-comments-import-standard"
          | "crm-comments-import-custom"
          | "code-cases-import-standard"
          | "code-cases-import-custom"
          | "code-actions-import-standard"
          | "code-actions-import-custom"
          | "code-attachments-import-standard"
          | "code-attachments-import-custom"
          | "code-violations-import-standard"
          | "code-violations-import-custom"
          | "code-addresses-import-standard"
          | "code-addresses-import-custom"
          | "document-generation-generate-bulk"
          | "document-generation-generate-test"
          | "gis-layers-to-csv"
          | "ce-after-update"
          | "crm-after-update"
          | "transactions-bulk-index"
          | "re-index-retry"
          | "data-sync-integration-push-record"
          | "data-sync-integration-pull-record"
          | "data-sync-integration-poll-records"
          | "data-sync-integration-sync-records"
          | "upload-urls-to-s3"
          | "delete-s3-folder"
          | "billing-notify-nightly"
          | "file-temp-cleanup"
          | "thumbnail-generation"
          | "transcode-video"
          | "send-email"
          | "inspection-unscheduled-email-nightly-job"
          | "opt-out-deactivated-numbers-job"
          | "gis-spatial-reference-update"
          | "check-refresh-tokens";
        userId?: number;
        /** @default "Pending" */
        status?: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
        jobDetails?: any;
        /** @default false */
        isTest?: boolean;
        /** @default 1 */
        stepTotal?: number;
        /** @default 1 */
        stepCurrent?: number;
        stepProgressMessage?: string;
        /** @default 0 */
        progressPercentage?: number;
        progressMessage?: string;
        /** @default 0 */
        recordsProcessed?: number;
        /** @default 0 */
        errorCount?: number;
        s3ResultsKey?: string;
        results?: any;
        /**
         * @format date-time
         * @default "2025-01-15T17:19:38.845Z"
         */
        startedAt?: string;
        /** @format date-time */
        endedAt?: string;
        /** @format date-time */
        cancelRequestedAt?: string;
        emailResultsTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/background-jobs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsActiveJobsList
     * @request GET:/core/background-jobs/active-jobs
     * @secure
     */
    backgroundJobsActiveJobsList: (params: RequestParams = {}) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: any;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: any;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/background-jobs/active-jobs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsResultsCreate
     * @request POST:/core/background-jobs/results
     * @secure
     */
    backgroundJobsResultsCreate: (
      data: {
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          signedUrl: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/background-jobs/results`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsCancelJobUpdate
     * @request PUT:/core/background-jobs/cancel-job
     * @secure
     */
    backgroundJobsCancelJobUpdate: (
      data: {
        coreBackgroundJobId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/background-jobs/cancel-job`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsActiveJobTypesList
     * @request GET:/core/background-jobs/active-job-types
     * @secure
     */
    backgroundJobsActiveJobTypesList: (params: RequestParams = {}) =>
      this.request<
        Record<string, boolean>,
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/background-jobs/active-job-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves country data (states, postal code format, iso2, etc.) for all countries.
     *
     * @tags Country
     * @name CountriesList
     * @summary Retrieve country data
     * @request GET:/core/countries
     */
    countriesList: (params: RequestParams = {}) =>
      this.request<
        Record<
          string,
          {
            id: string;
            countryName: string;
            callingCode: string;
            iso3: string;
            postalFirst: boolean;
            hasStateInAddress: boolean;
            postalFormat: string | null;
            states: string[] | null;
          }
        >,
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/countries`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Fields
     * @name CustomFieldsList
     * @request GET:/core/custom-fields
     * @secure
     */
    customFieldsList: (
      query: {
        resourceType: "Location";
        /** @default 0 */
        resourceId?: number;
        /** @default "false" */
        includeDeactivated?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resourceType: "Location";
          type:
            | "Address"
            | "Checkbox"
            | "Currency"
            | "Date"
            | "DateTime"
            | "Dropdown"
            | "DropdownMultiSelect"
            | "Email"
            | "Number"
            | "Percent"
            | "PhoneNumber"
            | "Text"
            | "TextArea"
            | "Time"
            | "URL";
          id: number;
          cityId: number;
          resourceId: number;
          label: string;
          name: string;
          description: string;
          required: boolean;
          standardField: boolean;
          decimalPlaces: number | null;
          unit: string | null;
          picklistId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
          picklist: {
            id: number;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            items: {
              id: number;
              value: string;
              order: number;
              picklistId: number;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
            }[];
          };
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/custom-fields`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Fields
     * @name CustomFieldsCreate
     * @request POST:/core/custom-fields
     * @secure
     */
    customFieldsCreate: (
      data: {
        resourceType: "Location";
        type:
          | "Address"
          | "Checkbox"
          | "Currency"
          | "Date"
          | "DateTime"
          | "Dropdown"
          | "DropdownMultiSelect"
          | "Email"
          | "Number"
          | "Percent"
          | "PhoneNumber"
          | "Text"
          | "TextArea"
          | "Time"
          | "URL";
        resourceId: number;
        /**
         * @minLength 1
         * @maxLength 190
         */
        label: string;
        /**
         * @minLength 1
         * @maxLength 190
         */
        name: string;
        /** @maxLength 190 */
        description: string;
        required: boolean;
        standardField: boolean;
        decimalPlaces: number | null;
        /** @maxLength 20 */
        unit: string | null;
        picklist?: {
          /**
           * @maxItems 100
           * @minItems 1
           */
          items: {
            /** @default 0 */
            order?: number;
            /**
             * @minLength 1
             * @maxLength 100
             */
            value: string;
          }[];
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resourceType: "Location";
          type:
            | "Address"
            | "Checkbox"
            | "Currency"
            | "Date"
            | "DateTime"
            | "Dropdown"
            | "DropdownMultiSelect"
            | "Email"
            | "Number"
            | "Percent"
            | "PhoneNumber"
            | "Text"
            | "TextArea"
            | "Time"
            | "URL";
          id: number;
          cityId: number;
          resourceId: number;
          label: string;
          name: string;
          description: string;
          required: boolean;
          standardField: boolean;
          decimalPlaces: number | null;
          unit: string | null;
          picklistId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/custom-fields`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name DataImportsImportDefinitionCreate
     * @request POST:/core/data-imports/import-definition
     * @secure
     */
    dataImportsImportDefinitionCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        s3filename: string;
        /** @minLength 1 */
        importType: string;
        /**
         * @minLength 1
         * @maxLength 100
         */
        name: string;
        /**
         * @minLength 0
         * @maxLength 1
         */
        csvDelimiter: string;
        specialInstructions?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          importType:
            | "Locations"
            | "Contacts"
            | "Permits"
            | "PermitAttachments"
            | "CrmRequests"
            | "CrmAttachments"
            | "CrmComments"
            | "CodeCases"
            | "CodeActions"
            | "CodeAttachments"
            | "CodeViolations"
            | "CodeAddresses";
          id: number;
          cityId: number;
          name: string;
          awsDataBrewProjectName: string;
          specialInstructions: string;
          availableToAgency: boolean;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/data-imports/import-definition`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name DataImportsImportDefinitionDelete
     * @request DELETE:/core/data-imports/import-definition
     * @secure
     */
    dataImportsImportDefinitionDelete: (
      data: {
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          importType:
            | "Locations"
            | "Contacts"
            | "Permits"
            | "PermitAttachments"
            | "CrmRequests"
            | "CrmAttachments"
            | "CrmComments"
            | "CodeCases"
            | "CodeActions"
            | "CodeAttachments"
            | "CodeViolations"
            | "CodeAddresses";
          id: number;
          cityId: number;
          name: string;
          awsDataBrewProjectName: string;
          specialInstructions: string;
          availableToAgency: boolean;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/data-imports/import-definition`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name DataImportsImportDefinitionList
     * @request GET:/core/data-imports/import-definition
     * @secure
     */
    dataImportsImportDefinitionList: (params: RequestParams = {}) =>
      this.request<
        {
          importType:
            | "Locations"
            | "Contacts"
            | "Permits"
            | "PermitAttachments"
            | "CrmRequests"
            | "CrmAttachments"
            | "CrmComments"
            | "CodeCases"
            | "CodeActions"
            | "CodeAttachments"
            | "CodeViolations"
            | "CodeAddresses";
          id: number;
          cityId: number;
          name: string;
          awsDataBrewProjectName: string;
          specialInstructions: string;
          availableToAgency: boolean;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/data-imports/import-definition`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name DataImportsDefAvailabilityUpdate
     * @request PUT:/core/data-imports/def-availability
     * @secure
     */
    dataImportsDefAvailabilityUpdate: (
      data: {
        id: number;
        availableToAgency: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          importType:
            | "Locations"
            | "Contacts"
            | "Permits"
            | "PermitAttachments"
            | "CrmRequests"
            | "CrmAttachments"
            | "CrmComments"
            | "CodeCases"
            | "CodeActions"
            | "CodeAttachments"
            | "CodeViolations"
            | "CodeAddresses";
          id: number;
          cityId: number;
          name: string;
          awsDataBrewProjectName: string;
          specialInstructions: string;
          availableToAgency: boolean;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/data-imports/def-availability`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name DataImportsSpecialInstructionsUpdate
     * @request PUT:/core/data-imports/special-instructions
     * @secure
     */
    dataImportsSpecialInstructionsUpdate: (
      data: {
        id: number;
        specialInstructions: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          importType:
            | "Locations"
            | "Contacts"
            | "Permits"
            | "PermitAttachments"
            | "CrmRequests"
            | "CrmAttachments"
            | "CrmComments"
            | "CodeCases"
            | "CodeActions"
            | "CodeAttachments"
            | "CodeViolations"
            | "CodeAddresses";
          id: number;
          cityId: number;
          name: string;
          awsDataBrewProjectName: string;
          specialInstructions: string;
          availableToAgency: boolean;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/data-imports/special-instructions`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get core documents
     *
     * @tags Documents
     * @name DocumentsList
     * @request GET:/core/documents
     * @secure
     */
    documentsList: (
      query?: {
        /** @default false */
        deactivated?: boolean;
        resourceType?: "Permit" | "PermitsStep";
        resourceIds?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resourceType: "Permit" | "PermitsStep" | null;
          id: number;
          cityId: number;
          s3Url: string | null;
          s3Bucket: string | null;
          s3Key: string | null;
          resourceId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          issuedAt: string | null;
          manyDocumentTemplates: {
            id: number;
            documentId: number;
            documentTemplateId: number;
            documentTemplate: {
              resourceType: "Permits";
              id: number;
              cityId: number;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              deactivatedAt: string | null;
              name: string;
              description: string | null;
              s3Url: string | null;
              isPublic: boolean | null;
            };
          }[];
        }[],
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event Logger
     * @name EventLoggerCreate
     * @request POST:/core/event-logger
     * @secure
     */
    eventLoggerCreate: (
      data: {
        ids?: string[] | null;
        logType?: (string & "General") | "DataSync" | "DocumentGeneration" | "Email" | "GisCopy";
        eventName: string;
        message: string;
        severity?: (string & "Info") | "Warn" | "Error" | "Debug";
        context?: string | null;
        userId?: number | null;
      }[],
      params: RequestParams = {},
    ) =>
      this.request<
        {
          totalLogs: number;
          successfulLogs: number;
          failedLogs: number;
          erroredDocuments?: any[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/event-logger`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Enqueue Site Export Job
     *
     * @tags Export Site
     * @name ExportCreate
     * @request POST:/core/export
     * @secure
     */
    exportCreate: (
      data: {
        jobType: "crm-export" | "ce-export";
        email: string;
        skipFiles?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get feature flags for a site, optionally filtered by feature flag names
     *
     * @tags Feature Flags
     * @name FeatureFlagsList
     * @request GET:/core/feature-flags
     */
    featureFlagsList: (
      query?: {
        featureNames?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          featureName: string;
          isActive: boolean;
        }[],
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/feature-flags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a presigned URL to upload a file to S3
     *
     * @tags File Upload
     * @name FileCreate
     * @request POST:/core/file
     * @secure
     */
    fileCreate: (
      query: {
        usage:
          | "Permits"
          | "CE"
          | "CRM"
          | "InspectionItemCommentAttachments"
          | "InspectionAttachmentVideoOriginal"
          | "SiteAssets"
          | "NotifyVoiceResources";
        fileName: string;
        mimeType: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: string;
          uuid: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/file`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyIntegrationCreate
     * @request POST:/core/gis-copy/integration
     * @secure
     */
    gisCopyIntegrationCreate: (
      data: {
        /** @minLength 1 */
        mapUrl: string;
        /** @minLength 1 */
        authType: string;
        /** @minLength 1 */
        authUser?: string;
        /** @minLength 1 */
        authPassword?: string;
        /** @minLength 1 */
        authUrl?: string;
        /** @minLength 1 */
        apiKey?: string;
        /** @default [] */
        adminContactEmails?: string[];
        adminNotes?: string;
        /** @default [] */
        layers?: {
          id?: number;
          /** @minLength 1 */
          name: string;
          /** @minLength 1 */
          urlPath: string;
          frequency: "Weekly" | "Monthly" | "Quarterly" | "Annually";
          /** @default [] */
          fields?: string[];
          afterCopy: "None" | "Import";
          importDefId?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          authType: "Anonymous" | "Authenticated" | "ApiKey";
          id: number;
          cityId: number;
          userId: number | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          name: string;
          mapUrl: string;
          authUser: string | null;
          authPasswordEncrypted: string | null;
          authUrl: string | null;
          apiKey: string | null;
          /** @format date-time */
          lastTestConnectionSuccessAt: string | null;
          /** @format date-time */
          lastTestConnectionError: string | null;
          adminContactEmails: string;
          adminNotes: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/integration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyIntegrationUpdate
     * @request PUT:/core/gis-copy/integration/{id}
     * @secure
     */
    gisCopyIntegrationUpdate: (
      id: number,
      data: {
        /** @minLength 1 */
        mapUrl: string;
        /** @minLength 1 */
        authType: string;
        /** @minLength 1 */
        authUser?: string;
        /** @minLength 1 */
        authPassword?: string;
        /** @minLength 1 */
        authUrl?: string;
        /** @minLength 1 */
        apiKey?: string;
        /** @default [] */
        adminContactEmails?: string[];
        adminNotes?: string;
        /** @default [] */
        layers?: {
          id?: number;
          /** @minLength 1 */
          name: string;
          /** @minLength 1 */
          urlPath: string;
          frequency: "Weekly" | "Monthly" | "Quarterly" | "Annually";
          /** @default [] */
          fields?: string[];
          afterCopy: "None" | "Import";
          importDefId?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          authType: "Anonymous" | "Authenticated" | "ApiKey";
          id: number;
          cityId: number;
          userId: number | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          name: string;
          mapUrl: string;
          authUser: string | null;
          authPasswordEncrypted: string | null;
          authUrl: string | null;
          apiKey: string | null;
          /** @format date-time */
          lastTestConnectionSuccessAt: string | null;
          /** @format date-time */
          lastTestConnectionError: string | null;
          adminContactEmails: string;
          adminNotes: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/integration/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyIntegrationDetail
     * @request GET:/core/gis-copy/integration/{id}
     * @secure
     */
    gisCopyIntegrationDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          authType: "Anonymous" | "Authenticated" | "ApiKey";
          id: number;
          cityId: number;
          userId: number | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          name: string;
          mapUrl: string;
          authUser: string | null;
          authPasswordEncrypted: string | null;
          authUrl: string | null;
          apiKey: string | null;
          /** @format date-time */
          lastTestConnectionSuccessAt: string | null;
          /** @format date-time */
          lastTestConnectionError: string | null;
          adminContactEmails: string;
          adminNotes: string | null;
          layers: {
            syncFrequency: "Weekly" | "Monthly" | "Quarterly" | "Annually";
            afterCopy: "None" | "Import";
            id: number;
            cityId: number;
            userId: number | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            startedAt: string | null;
            name: string;
            urlPath: string;
            fields: string;
            CoreIntegrationEsriSettingId: number | null;
            CoreImportDefinitionId: number | null;
            /** @format date-time */
            lastSyncAt: string | null;
            fieldOptions?: string[];
          }[];
          /** @default false */
          syncing?: boolean;
          enabled?: boolean;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/integration/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyEnableIntegrationUpdate
     * @request PUT:/core/gis-copy/enable-integration
     * @secure
     */
    gisCopyEnableIntegrationUpdate: (
      data: {
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          authType: "Anonymous" | "Authenticated" | "ApiKey";
          id: number;
          cityId: number;
          userId: number | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          name: string;
          mapUrl: string;
          authUser: string | null;
          authPasswordEncrypted: string | null;
          authUrl: string | null;
          apiKey: string | null;
          /** @format date-time */
          lastTestConnectionSuccessAt: string | null;
          /** @format date-time */
          lastTestConnectionError: string | null;
          adminContactEmails: string;
          adminNotes: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/enable-integration`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyDisableIntegrationUpdate
     * @request PUT:/core/gis-copy/disable-integration
     * @secure
     */
    gisCopyDisableIntegrationUpdate: (
      data: {
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          authType: "Anonymous" | "Authenticated" | "ApiKey";
          id: number;
          cityId: number;
          userId: number | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          name: string;
          mapUrl: string;
          authUser: string | null;
          authPasswordEncrypted: string | null;
          authUrl: string | null;
          apiKey: string | null;
          /** @format date-time */
          lastTestConnectionSuccessAt: string | null;
          /** @format date-time */
          lastTestConnectionError: string | null;
          adminContactEmails: string;
          adminNotes: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/disable-integration`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyDeleteIntegrationDelete
     * @request DELETE:/core/gis-copy/delete-integration/{id}
     * @secure
     */
    gisCopyDeleteIntegrationDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          authType: "Anonymous" | "Authenticated" | "ApiKey";
          id: number;
          cityId: number;
          userId: number | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          name: string;
          mapUrl: string;
          authUser: string | null;
          authPasswordEncrypted: string | null;
          authUrl: string | null;
          apiKey: string | null;
          /** @format date-time */
          lastTestConnectionSuccessAt: string | null;
          /** @format date-time */
          lastTestConnectionError: string | null;
          adminContactEmails: string;
          adminNotes: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/delete-integration/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyRetrieveLayerCreate
     * @request POST:/core/gis-copy/retrieve-layer
     * @secure
     */
    gisCopyRetrieveLayerCreate: (
      data: {
        /** @minLength 1 */
        layerUrl: string;
        /** @minLength 1 */
        authType: string;
        /** @minLength 1 */
        authUser?: string;
        /** @minLength 1 */
        authPassword?: string;
        /** @minLength 1 */
        apiKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          name: string;
          fields: any[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/retrieve-layer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyTestIntegrationCreate
     * @request POST:/core/gis-copy/test-integration
     * @secure
     */
    gisCopyTestIntegrationCreate: (
      data: {
        esriSettingId: number;
        /** @minLength 1 */
        authType: string;
        /** @minLength 1 */
        authUser?: string;
        /** @minLength 1 */
        authPassword?: string;
        /** @minLength 1 */
        apiKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          version?: number;
          error?: string;
          /** @default [] */
          layers?: {
            layer: string;
            name?: string;
            maxRecordCount?: number;
            fields?: Record<string, boolean>;
            error?: string;
          }[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/test-integration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopyIntegrationsList
     * @request GET:/core/gis-copy/integrations
     * @secure
     */
    gisCopyIntegrationsList: (params: RequestParams = {}) =>
      this.request<
        {
          authType: "Anonymous" | "Authenticated" | "ApiKey";
          id: number;
          cityId: number;
          userId: number | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          name: string;
          mapUrl: string;
          authUser: string | null;
          authPasswordEncrypted: string | null;
          authUrl: string | null;
          apiKey: string | null;
          /** @format date-time */
          lastTestConnectionSuccessAt: string | null;
          /** @format date-time */
          lastTestConnectionError: string | null;
          adminContactEmails: string;
          adminNotes: string | null;
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/integrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Copy
     * @name GisCopySyncCreate
     * @request POST:/core/gis-copy/sync
     * @secure
     */
    gisCopySyncCreate: (
      data: {
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/gis-copy/sync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Spatial Reference
     * @name GisSpatialReferenceCreate
     * @request POST:/core/gis-spatial-reference
     * @secure
     */
    gisSpatialReferenceCreate: (
      data: {
        GisSpatialJobType: "ReProject" | "Geocode";
        recordType: "CRM" | "CE";
        readOnly: boolean;
        min: {
          lat?: number;
          lon?: number;
        };
        max: {
          lat?: number;
          lon?: number;
        };
        oldWellKnownID?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          backgroundJobId: number;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/gis-spatial-reference`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Spatial Reference
     * @name GisSpatialReferenceList
     * @request GET:/core/gis-spatial-reference
     * @secure
     */
    gisSpatialReferenceList: (params: RequestParams = {}) =>
      this.request<
        {
          backgroundJobId: number | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/gis-spatial-reference`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GIS Spatial Reference
     * @name GisSpatialReferenceDelete
     * @request DELETE:/core/gis-spatial-reference
     * @secure
     */
    gisSpatialReferenceDelete: (params: RequestParams = {}) =>
      this.request<
        {
          backgroundJobId: number | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/gis-spatial-reference`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all inspections for a given city
     *
     * @tags Inspections
     * @name InspectionsList
     * @request GET:/core/inspections
     * @secure
     */
    inspectionsList: (
      query?: {
        inspectable_id?: string | null;
        inspectable_type?: string | null;
        record_id?: string | null;
        record_type?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new inspection-type for a given city
     *
     * @tags Inspections
     * @name InspectionsCreate
     * @request POST:/core/inspections
     * @secure
     */
    inspectionsCreate: (
      data: {
        data: {
          attributes: {
            inspectable_type?: string | null;
            inspectable_id?: number | null;
            inspections_type_id: number;
            applicant_id: number;
            assignee_id: number;
            record_id?: number | null;
            record_type?: string | null;
            record_name?: string | null;
            primary_location_id?: number | null;
            parent_id?: number | null;
            address?: {
              attn?: string | null;
              address: string;
              address2?: string | null;
              city: string;
              state: string;
              zip: string;
              /** @default "US" */
              country_id?: string;
            };
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get ALL locations. [NOTE] This endpoint isn't paginated, but really should be
     *
     * @tags Locations
     * @name LocationsList
     * @request GET:/core/locations
     * @secure
     */
    locationsList: (params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          parcelNumber: string;
          locationAddressId: number | null;
          locationName: string | null;
          ownerName: string | null;
          ownerAddressId: number | null;
          ownerEmail: string | null;
          ownerPhone: string | null;
          lotSize: number | null;
          zoning: string | null;
          yearBuilt: number | null;
          buildingTypeId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
          externalId: string | null;
          customFieldValues: {
            id: number;
            valueString: string | null;
            valueBoolean: boolean | null;
            valueInt: number | null;
            valueFloat: number | null;
            /** @format date-time */
            valueDatetime: string | null;
            valueJson?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
            valueAddressId: number | null;
            valuePicklistItemId: number | null;
            /** @format date-time */
            rowTimestamp: string;
            customFieldId: number;
            locationId: number | null;
            customField: {
              resourceType: "Location";
              type:
                | "Address"
                | "Checkbox"
                | "Currency"
                | "Date"
                | "DateTime"
                | "Dropdown"
                | "DropdownMultiSelect"
                | "Email"
                | "Number"
                | "Percent"
                | "PhoneNumber"
                | "Text"
                | "TextArea"
                | "Time"
                | "URL";
              id: number;
              cityId: number;
              resourceId: number;
              label: string;
              name: string;
              description: string;
              required: boolean;
              standardField: boolean;
              decimalPlaces: number | null;
              unit: string | null;
              picklistId: number | null;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
            };
          }[];
        }[],
        any
      >({
        path: `/core/locations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsCreate
     * @request POST:/core/locations
     * @secure
     */
    locationsCreate: (
      data: {
        parcelNumber: string;
        locationName: string | null;
        ownerName: string | null;
        ownerEmail: string | null;
        ownerPhone: string | null;
        lotSize: number | null;
        zoning: string | null;
        yearBuilt: number | null;
        buildingTypeId: number | null;
        customFieldValues: {
          valueString: string | null;
          valueBoolean: boolean | null;
          valueInt: number | null;
          valueFloat: number | null;
          /** @format date-time */
          valueDatetime: string | null;
          valueJson?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          valuePicklistItemId: number | null;
          customFieldId: number;
          valueAddress: {
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            countryId: string;
          };
          valuePicklistItemIds: number[] | null;
        }[];
        locationAddress: {
          attn: string | null;
          address: string;
          address2: string | null;
          city: string;
          state: string;
          zip: string;
          countryId: string;
        };
        ownerAddress: {
          attn: string | null;
          address: string;
          address2: string | null;
          city: string;
          state: string;
          zip: string;
          countryId: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          parcelNumber: string;
          locationAddressId: number | null;
          locationName: string | null;
          ownerName: string | null;
          ownerAddressId: number | null;
          ownerEmail: string | null;
          ownerPhone: string | null;
          lotSize: number | null;
          zoning: string | null;
          yearBuilt: number | null;
          buildingTypeId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
          externalId: string | null;
          customFieldValues: {
            id: number;
            valueString: string | null;
            valueBoolean: boolean | null;
            valueInt: number | null;
            valueFloat: number | null;
            /** @format date-time */
            valueDatetime: string | null;
            valueJson?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
            valueAddressId: number | null;
            valuePicklistItemId: number | null;
            /** @format date-time */
            rowTimestamp: string;
            customFieldId: number;
            locationId: number | null;
            customField: {
              resourceType: "Location";
              type:
                | "Address"
                | "Checkbox"
                | "Currency"
                | "Date"
                | "DateTime"
                | "Dropdown"
                | "DropdownMultiSelect"
                | "Email"
                | "Number"
                | "Percent"
                | "PhoneNumber"
                | "Text"
                | "TextArea"
                | "Time"
                | "URL";
              id: number;
              cityId: number;
              resourceId: number;
              label: string;
              name: string;
              description: string;
              required: boolean;
              standardField: boolean;
              decimalPlaces: number | null;
              unit: string | null;
              picklistId: number | null;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
              picklist: {
                id: number;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                items: {
                  id: number;
                  value: string;
                  order: number;
                  picklistId: number;
                  /** @format date-time */
                  deactivatedAt: string | null;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  /** @format date-time */
                  rowTimestamp: string;
                }[];
              };
            };
            valueAddress: {
              id?: number;
              attn: string | null;
              address: string;
              address2: string | null;
              city: string;
              state: string;
              zip: string;
              /** @format date-time */
              rowTimestamp: string;
              countryId: string;
            };
            valuePicklistItem: {
              id: number;
              value: string;
              order: number;
              picklistId: number;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
            };
            valueManyPicklistItems: {
              id: number;
              coreCustomFieldValueId: number;
              corePicklistItemId: number;
              /** @format date-time */
              rowTimestamp: string;
              corePicklistItem: {
                id: number;
                value: string;
                order: number;
                picklistId: number;
                /** @format date-time */
                deactivatedAt: string | null;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                /** @format date-time */
                rowTimestamp: string;
              };
            }[];
          }[];
          locationAddress: {
            id?: number;
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            /** @format date-time */
            rowTimestamp: string;
            countryId: string;
          };
          ownerAddress: {
            id?: number;
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            /** @format date-time */
            rowTimestamp: string;
            countryId: string;
          };
          buildingType: {
            id: number;
            value: string;
            order: number;
            picklistId: number;
            /** @format date-time */
            deactivatedAt: string | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @format date-time */
            rowTimestamp: string;
          };
        },
        | (
            | {
                statusCode: number;
                error: string;
                message: string;
                missingCustomFields?: {
                  resourceType: "Location";
                  type:
                    | "Address"
                    | "Checkbox"
                    | "Currency"
                    | "Date"
                    | "DateTime"
                    | "Dropdown"
                    | "DropdownMultiSelect"
                    | "Email"
                    | "Number"
                    | "Percent"
                    | "PhoneNumber"
                    | "Text"
                    | "TextArea"
                    | "Time"
                    | "URL";
                  id: number;
                  cityId: number;
                  resourceId: number;
                  label: string;
                  name: string;
                  description: string;
                  required: boolean;
                  standardField: boolean;
                  decimalPlaces: number | null;
                  unit: string | null;
                  picklistId: number | null;
                  /** @format date-time */
                  deactivatedAt: string | null;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  /** @format date-time */
                  rowTimestamp: string;
                }[];
                excessCustomFieldValues?: any[];
              }
            | {
                statusCode: number;
                error: string;
                message: string;
              }
          )
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/locations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Release Notes
     * @name ReleaseNotesList
     * @request GET:/core/release-notes/
     * @secure
     */
    releaseNotesList: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/core/release-notes/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags File Upload
     * @name UploadToolCredentialsList
     * @request GET:/core/upload-tool/credentials
     * @secure
     */
    uploadToolCredentialsList: (params: RequestParams = {}) =>
      this.request<
        {
          accessKey: string;
          secretKey: string;
          sessionToken: string;
          /** @format date-time */
          expiration: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/upload-tool/credentials`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File Upload
     * @name UploadToolFolderCreate
     * @request POST:/core/upload-tool/folder
     * @secure
     */
    uploadToolFolderCreate: (
      data: {
        /** @minLength 1 */
        folderName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          folderName: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/upload-tool/folder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File Upload
     * @name UploadToolFolderList
     * @request GET:/core/upload-tool/folder
     * @secure
     */
    uploadToolFolderList: (params: RequestParams = {}) =>
      this.request<
        {
          folders: string[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/upload-tool/folder`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File Upload
     * @name UploadToolFolderDelete
     * @request DELETE:/core/upload-tool/folder
     * @secure
     */
    uploadToolFolderDelete: (
      data: {
        /** @minLength 1 */
        folderName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          folderName: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/upload-tool/folder`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File Upload
     * @name UploadToolUrlsCreate
     * @request POST:/core/upload-tool/urls
     * @secure
     */
    uploadToolUrlsCreate: (
      data: {
        /** @minLength 1 */
        folderName: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/upload-tool/urls`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get general agency settings, such as timezone information. Endpoint is left unsecured intentionally.
     *
     * @tags Agency
     * @name AgencySettingsList
     * @summary Get general agency settings
     * @request GET:/core/agency/settings
     */
    agencySettingsList: (params: RequestParams = {}) =>
      this.request<
        {
          timezoneInfo: {
            timezone: string;
            utcOffset: number;
            namedOffset: string;
            agencyConfig: {
              pstOffset: number;
              dstIsObserved: boolean;
            };
          };
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/agency/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Verify a JWT token
     *
     * @tags Auth
     * @name AuthValidateCreate
     * @request POST:/core/auth/validate
     */
    authValidateCreate: (params: RequestParams = {}) =>
      this.request<
        {
          isValid: boolean;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/auth/validate`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsDetail
     * @request GET:/core/background-jobs/{id}
     * @secure
     */
    backgroundJobsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
          user: {
            personId: number;
            firstName: string;
            lastName: string;
          } | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/background-jobs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Background Jobs
     * @name BackgroundJobsUpdate
     * @request PUT:/core/background-jobs/{id}
     * @secure
     */
    backgroundJobsUpdate: (
      id: number,
      data: {
        recordsTotal?: number;
        status?: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
        jobDetails?: any;
        isTest?: boolean;
        stepTotal?: number;
        stepCurrent?: number;
        stepProgressMessage?: string;
        progressPercentage?: number;
        progressMessage?: string;
        recordsProcessed?: number;
        errorCount?: number;
        s3ResultsKey?: string;
        results?: any;
        /** @format date-time */
        startedAt?: string;
        /** @format date-time */
        endedAt?: string;
        /** @format date-time */
        cancelRequestedAt?: string;
        emailResultsTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/background-jobs/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CE Cases
     * @name CeCasesList
     * @request GET:/core/ce/cases
     * @secure
     */
    ceCasesList: (
      query?: {
        ids?: string;
        has_attachment?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              "primary-attachment-url": string | null;
              "primary-thumbnail-url": string | null;
            };
          }[];
        },
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/ce/cases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a list of the agency's CE custom fields.
     *
     * @tags CE
     * @name CeCustomFieldsList
     * @request GET:/core/ce/custom-fields
     * @secure
     */
    ceCustomFieldsList: (params: RequestParams = {}) =>
      this.request<
        {
          caseExtensionId: number;
          cityId: number;
          fieldName: string;
          defaultValue: string;
          requiredMsg: string;
          /** @format date-time */
          rowTimestamp: string;
        }[],
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/ce/custom-fields`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get an agency's CE general settings.
     *
     * @tags CE
     * @name CeGeneralSettingsList
     * @request GET:/core/ce/general-settings
     * @secure
     */
    ceGeneralSettingsList: (params: RequestParams = {}) =>
      this.request<
        {
          useLocationLookup: boolean;
        },
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/ce/general-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an agency's CE general settings.
     *
     * @tags CE
     * @name CeGeneralSettingsPartialUpdate
     * @request PATCH:/core/ce/general-settings
     * @secure
     */
    ceGeneralSettingsPartialUpdate: (
      data: {
        useLocationLookup: boolean;
        fieldMapping?: {
          id?: number;
          locationFieldId: number;
          ceExtensionDefId?: number;
          ceTargetedField?:
            | "PropertyAlert"
            | "PropertyOccupant"
            | "PropertyPhone"
            | "PropertyCell"
            | "PropertyEmail"
            | "EnforceZone"
            | "PropertyStatus"
            | "Subdivision"
            | "Classification"
            | "SubClassification"
            | "Flag1"
            | "Flag2"
            | "Flag3"
            | "Flag4";
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          useLocationLookup: boolean;
          upsertedMappings?: {
            cityId: number;
            id: number;
            locationCustomFieldId: number;
            ceCaseExtensionDefId: number | null;
            targetedCEField:
              | "PropertyAlert"
              | "PropertyOccupant"
              | "PropertyPhone"
              | "PropertyCell"
              | "PropertyEmail"
              | "EnforceZone"
              | "PropertyStatus"
              | "Subdivision"
              | "Classification"
              | "SubClassification"
              | "Flag1"
              | "Flag2"
              | "Flag3"
              | "Flag4"
              | null;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/ce/general-settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportCaseStandardImportCreate
     * @request POST:/core/ce/import/case-standard-import
     * @secure
     */
    ceImportCaseStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/case-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportCaseCustomImportCreate
     * @request POST:/core/ce/import/case-custom-import
     * @secure
     */
    ceImportCaseCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/case-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportActionStandardImportCreate
     * @request POST:/core/ce/import/action-standard-import
     * @secure
     */
    ceImportActionStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/action-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportActionCustomImportCreate
     * @request POST:/core/ce/import/action-custom-import
     * @secure
     */
    ceImportActionCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/action-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportAttachmentStandardImportCreate
     * @request POST:/core/ce/import/attachment-standard-import
     * @secure
     */
    ceImportAttachmentStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/attachment-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportAttachmentCustomImportCreate
     * @request POST:/core/ce/import/attachment-custom-import
     * @secure
     */
    ceImportAttachmentCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/attachment-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportViolationStandardImportCreate
     * @request POST:/core/ce/import/violation-standard-import
     * @secure
     */
    ceImportViolationStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/violation-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportViolationCustomImportCreate
     * @request POST:/core/ce/import/violation-custom-import
     * @secure
     */
    ceImportViolationCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/violation-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportAddressStandardImportCreate
     * @request POST:/core/ce/import/address-standard-import
     * @secure
     */
    ceImportAddressStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/address-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CeImportAddressCustomImportCreate
     * @request POST:/core/ce/import/address-custom-import
     * @secure
     */
    ceImportAddressCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/import/address-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Code Properties
     * @name CePropertiesList
     * @request GET:/core/ce/properties
     * @secure
     */
    cePropertiesList: (
      query?: {
        ids?: string;
        limit?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              "city-id": number;
              alert: string | null;
            };
          }[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/properties`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Code Statuses
     * @name CeStatusesList
     * @request GET:/core/ce/statuses
     * @secure
     */
    ceStatusesList: (params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              name: string;
              order: number;
              category: string;
            };
          }[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/statuses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CE Topics
     * @name CeTopicsList
     * @request GET:/core/ce/topics
     * @secure
     */
    ceTopicsList: (params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              name: string;
            };
          }[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/topics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Violation Types
     * @name CeViolationTypesList
     * @request GET:/core/ce/violation-types
     * @secure
     */
    ceViolationTypesList: (params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              name: string;
              tag: string;
              code: string;
              "group-id": number;
              order: number;
            };
          }[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/ce/violation-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ContactsImportStandardImportCreate
     * @request POST:/core/contacts/import/standard-import
     * @secure
     */
    contactsImportStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/contacts/import/standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ContactsImportCustomImportCreate
     * @request POST:/core/contacts/import/custom-import
     * @secure
     */
    contactsImportCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/contacts/import/custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CrmImportRequestStandardImportCreate
     * @request POST:/core/crm/import/request-standard-import
     * @secure
     */
    crmImportRequestStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/import/request-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CrmImportRequestCustomImportCreate
     * @request POST:/core/crm/import/request-custom-import
     * @secure
     */
    crmImportRequestCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/import/request-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CrmImportAttachmentStandardImportCreate
     * @request POST:/core/crm/import/attachment-standard-import
     * @secure
     */
    crmImportAttachmentStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/import/attachment-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CrmImportAttachmentCustomImportCreate
     * @request POST:/core/crm/import/attachment-custom-import
     * @secure
     */
    crmImportAttachmentCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/import/attachment-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CrmImportCommentStandardImportCreate
     * @request POST:/core/crm/import/comment-standard-import
     * @secure
     */
    crmImportCommentStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/import/comment-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CrmImportCommentCustomImportCreate
     * @request POST:/core/crm/import/comment-custom-import
     * @secure
     */
    crmImportCommentCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/import/comment-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Crm Statuses
     * @name CrmStatusesList
     * @request GET:/core/crm/statuses
     * @secure
     */
    crmStatusesList: (params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              name: string;
              order: number;
              category: string;
            };
          }[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/statuses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Crm Topics
     * @name CrmTopicsList
     * @request GET:/core/crm/topics
     * @secure
     */
    crmTopicsList: (params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              name: string;
              "department-id": number;
              location: string | null;
            };
          }[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/crm/topics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update some properties of a custom field, update some properties of nested picklist, upsert nested picklist items
     *
     * @tags Custom Fields
     * @name CustomFieldsPartialUpdate
     * @request PATCH:/core/custom-fields/{id}
     * @secure
     */
    customFieldsPartialUpdate: (
      id: number,
      data: {
        resourceType?: "Location";
        type?:
          | "Address"
          | "Checkbox"
          | "Currency"
          | "Date"
          | "DateTime"
          | "Dropdown"
          | "DropdownMultiSelect"
          | "Email"
          | "Number"
          | "Percent"
          | "PhoneNumber"
          | "Text"
          | "TextArea"
          | "Time"
          | "URL";
        id?: number;
        cityId?: number;
        resourceId?: number;
        label?: string;
        name?: string;
        description?: string;
        required?: boolean;
        standardField?: boolean;
        decimalPlaces?: number | null;
        unit?: string | null;
        picklistId?: number | null;
        /** @format date-time */
        deactivatedAt?: string | null;
        /** @format date-time */
        createdAt?: string;
        /** @format date-time */
        updatedAt?: string;
        /** @format date-time */
        rowTimestamp?: string;
        picklist?: {
          id?: number;
          /** @format date-time */
          createdAt?: string;
          /** @format date-time */
          updatedAt?: string;
          items: {
            id?: number;
            value?: string;
            order?: number;
            picklistId?: number;
            /** @format date-time */
            deactivatedAt?: string | null;
            /** @format date-time */
            createdAt?: string;
            /** @format date-time */
            updatedAt?: string;
            /** @format date-time */
            rowTimestamp?: string;
          }[];
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resourceType: "Location";
          type:
            | "Address"
            | "Checkbox"
            | "Currency"
            | "Date"
            | "DateTime"
            | "Dropdown"
            | "DropdownMultiSelect"
            | "Email"
            | "Number"
            | "Percent"
            | "PhoneNumber"
            | "Text"
            | "TextArea"
            | "Time"
            | "URL";
          id: number;
          cityId: number;
          resourceId: number;
          label: string;
          name: string;
          description: string;
          required: boolean;
          standardField: boolean;
          decimalPlaces: number | null;
          unit: string | null;
          picklistId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/custom-fields/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name DataImportsImportTypesList
     * @request GET:/core/data-imports/import-types
     * @secure
     */
    dataImportsImportTypesList: (params: RequestParams = {}) =>
      this.request<
        {
          types: string[];
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/data-imports/import-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deactivate core documents. Ids is a comma separated list (e.g. ?ids=1,2,3)
     *
     * @tags Documents
     * @name DocumentsDeactivatedUpdate
     * @request PUT:/core/documents/deactivated
     * @secure
     */
    documentsDeactivatedUpdate: (
      query: {
        ids: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          count: number;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/deactivated`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Restore core documents. Ids is a comma separated list (e.g. ?ids=1,2,3)
     *
     * @tags Documents
     * @name DocumentsDeactivatedDelete
     * @request DELETE:/core/documents/deactivated
     * @secure
     */
    documentsDeactivatedDelete: (
      query: {
        ids: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          count: number;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/deactivated`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsTemplatesCreate
     * @request POST:/core/documents/templates
     * @secure
     */
    documentsTemplatesCreate: (
      data: {
        resourceType: "Permits";
        name: string;
        description: string | null;
        s3url: string;
        s3bucket: string;
        s3key: string;
        documentSubTypes?: {
          permitsTypeId: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resourceType: "Permits";
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          description: string | null;
          s3Url: string | null;
          isPublic: boolean | null;
          manyDocumentSubTypes?: {
            id: number;
            documentsTemplateId: number;
            permitsTypeId: number;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/templates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get All Document Templates, filtered by deactivation status and record type. Ids and permitsTypeIds are comma separated lists (e.g. ?ids=1,2,3).
     *
     * @tags Documents
     * @name DocumentsTemplatesList
     * @request GET:/core/documents/templates
     * @secure
     */
    documentsTemplatesList: (
      query?: {
        ids?: string;
        /** @default false */
        deactivated?: boolean;
        resourceType?: "Permits";
        permitsTypeIds?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resourceType: "Permits";
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          description: string | null;
          s3Url: string | null;
          isPublic: boolean | null;
          manyDocumentSubTypes?: {
            id: number;
            documentsTemplateId: number;
            permitsTypeId: number;
          }[];
        }[],
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event Logger
     * @name EventLoggerSearchCreate
     * @request POST:/core/event-logger/search
     * @secure
     */
    eventLoggerSearchCreate: (
      data: {
        ids?: string[] | null;
        userId?: number | null;
        search?: string;
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        cursor?: number;
        logType?: ((string & "General") | "DataSync" | "DocumentGeneration" | "Email" | "GisCopy")[] | null;
        severity?: ((string & "Info") | "Warn" | "Error" | "Debug")[] | null;
        sort?: {
          field: string;
          direction: "asc" | "desc";
        }[];
        /**
         * @min 1
         * @max 100
         * @default 10
         */
        take?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/event-logger/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Check if a feature flag is active for a site
     *
     * @tags Feature Flags
     * @name FeatureFlagsDetail
     * @request GET:/core/feature-flags/{name}
     */
    featureFlagsDetail: (name: string, params: RequestParams = {}) =>
      this.request<
        {
          enabled: boolean;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/feature-flags/${name}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Start a multipart upload to S3
     *
     * @tags File Upload
     * @name FileMultipartCreate
     * @request POST:/core/file/multipart
     * @secure
     */
    fileMultipartCreate: (
      query: {
        usage:
          | "Permits"
          | "CE"
          | "CRM"
          | "InspectionItemCommentAttachments"
          | "InspectionAttachmentVideoOriginal"
          | "SiteAssets"
          | "NotifyVoiceResources";
        fileName: string;
        mimeType: string;
        numParts: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          urls: string[];
          uuid: string;
          uploadId: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/file/multipart`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all inspection-types for a given city
     *
     * @tags Inspections
     * @name InspectionsDetail
     * @request GET:/core/inspections/{id}
     * @secure
     */
    inspectionsDetail: (
      id: number,
      query?: {
        previousItemStatus?: "passed" | "failed";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Hard delete an inspection by id
     *
     * @tags Inspections
     * @name InspectionsDelete
     * @request DELETE:/core/inspections/{id}
     * @secure
     */
    inspectionsDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all inspection-types for a given city
     *
     * @tags Inspections
     * @name InspectionsPublicList
     * @request GET:/core/inspections/public
     * @secure
     */
    inspectionsPublicList: (
      query?: {
        inspectable_id?: string | null;
        inspectable_type?: string | null;
        record_id?: string | null;
        record_type?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              status: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              comment: string | null;
              applicant?: any;
              assignee?: any;
              "record-id": number | null;
              inspectable_type: string | null;
              inspectable_id: number;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              onSiteContactApplicantInstructions?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              reInspection: {
                id: number;
                status: string;
              } | null;
              previousInspectionId?: number | null;
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/public`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the number of requested inspection for a city
     *
     * @tags Inspections
     * @name InspectionsRequestedList
     * @request GET:/core/inspections/requested
     * @secure
     */
    inspectionsRequestedList: (params: RequestParams = {}) =>
      this.request<
        {
          numberOfRequestedInspections: number;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/requested`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all inspection-types for a given city
     *
     * @tags Inspections
     * @name InspectionsTypesList
     * @request GET:/core/inspections/types
     * @secure
     */
    inspectionsTypesList: (
      query: {
        deactivated: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspections-type";
            attributes: {
              title: string;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              /** @format date-time */
              "deactivated-at": string | null;
            };
            relationships: {
              sections: {
                data: {
                  id: string;
                  type: "section";
                }[];
              };
            };
          }[];
          included: {
            id: string;
            type: "section";
            attributes: {
              title: string;
              order: number;
              "inspections-type-id": number | null;
              items: {
                id: number;
                title: string;
                type: string | null;
                order: number;
                inspections_types_section_id: number;
                /** @format date-time */
                created_at: string;
                /** @format date-time */
                updated_at: string;
                description: string | null;
                /** @format date-time */
                deleted_at: string | null;
              }[];
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new inspection-type for a given city
     *
     * @tags Inspections
     * @name InspectionsTypesCreate
     * @request POST:/core/inspections/types
     * @secure
     */
    inspectionsTypesCreate: (
      data: {
        data: {
          attributes: {
            title: string;
            citizenHelpText?: string;
            blockOutDays?: string[];
            sections_attributes?: {
              title: string;
              items_attributes?: (
                | {
                    /** @maxLength 1000 */
                    description?: string | null;
                    /** @maxLength 255 */
                    title: string;
                    id: number;
                    _destroy?: boolean;
                  }
                | {
                    /** @maxLength 1000 */
                    description?: string | null;
                    /** @maxLength 255 */
                    title: string;
                  }
              )[];
            }[];
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspections-type";
            attributes: {
              title: string;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              /** @format date-time */
              "deactivated-at": string | null;
            };
            relationships: {
              sections: {
                data: {
                  id: string;
                  type: "section";
                }[];
              };
            };
          };
          included: {
            id: string;
            type: "section";
            attributes: {
              title: string;
              order: number;
              "inspections-type-id": number | null;
              items: {
                id: number;
                title: string;
                type: string | null;
                order: number;
                inspections_types_section_id: number;
                /** @format date-time */
                created_at: string;
                /** @format date-time */
                updated_at: string;
                description: string | null;
                /** @format date-time */
                deleted_at: string | null;
              }[];
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Return the Filters for a given inspection list view
     *
     * @tags Inspections
     * @name InspectionsViewsList
     * @request GET:/core/inspections/views
     * @secure
     */
    inspectionsViewsList: (
      query?: {
        status?: string | null;
        date?: string | null;
        id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          inspectionTypes: string[];
          permitTypes: string[];
          q?: string;
          searchAfter?: any[];
          size?: number;
          assignee: string[];
          status: string[];
          scheduledDate?: {
            dateOption?: string;
            /** @format date-time */
            from?: string;
            /** @format date-time */
            to?: string;
          };
          sort: (
            | {
                _script: {
                  type: string;
                  script: {
                    lang: string;
                    source: string;
                  };
                  order: string;
                };
              }
            | {
                scheduled_date_time: {
                  order: string;
                  missing: string;
                };
              }
            | {
                _id: string;
              }
          )[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/views`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all data sync integrations for the city and all default configurations.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncList
     * @request GET:/core/integrations/data-sync
     * @secure
     */
    integrationsDataSyncList: (params: RequestParams = {}) =>
      this.request<
        {
          list: {
            productType: "CRM" | "CE" | "Notify" | "Permits";
            header: string;
            subHeader: string;
            cards: {
              integrationType:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              name: string;
              description: string;
              iconUrl: string;
              integrations?: {
                id: number;
                name: string;
                productType: "CRM" | "CE" | "Notify" | "Permits";
                integrationType:
                  | "Lucity"
                  | "Simplicity"
                  | "CityView"
                  | "Energov"
                  | "Cartegraph"
                  | "AssetEssentials"
                  | "CityWorks"
                  | "Accela"
                  | "Edgesoft";
              }[];
            }[];
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new data sync integration.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncCreate
     * @request POST:/core/integrations/data-sync
     * @secure
     */
    integrationsDataSyncCreate: (
      data: {
        settings:
          | {
              authType: "Anonymous";
              name: string;
              productType: "CRM" | "CE" | "Notify" | "Permits";
              integrationType:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              externalRecordType:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              dynamicExternalRecordType?: string;
              syncingFrequency:
                | "Realtime"
                | "Hourly"
                | "EveryThreeHours"
                | "Nightly"
                | "Weekly"
                | "Monthly"
                | "Quarterly"
                | "Yearly";
              pollingFrequency: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
              serverUrl: string;
              maxRequestsPerMinute?: number;
              maxRecordsPerRequest?: number;
              adminContactEmails?: string[];
              adminNotes?: string;
              portalUrl?: string;
              webhookHash?: string;
            }
          | {
              authType: "Authenticated";
              /** @minLength 1 */
              authPassword: string;
              authUser: string;
              name: string;
              productType: "CRM" | "CE" | "Notify" | "Permits";
              integrationType:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              externalRecordType:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              dynamicExternalRecordType?: string;
              syncingFrequency:
                | "Realtime"
                | "Hourly"
                | "EveryThreeHours"
                | "Nightly"
                | "Weekly"
                | "Monthly"
                | "Quarterly"
                | "Yearly";
              pollingFrequency: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
              serverUrl: string;
              maxRequestsPerMinute?: number;
              maxRecordsPerRequest?: number;
              adminContactEmails?: string[];
              adminNotes?: string;
              portalUrl?: string;
              webhookHash?: string;
            }
          | {
              authType: "ApiKey";
              apiKey: string;
              name: string;
              productType: "CRM" | "CE" | "Notify" | "Permits";
              integrationType:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              externalRecordType:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              dynamicExternalRecordType?: string;
              syncingFrequency:
                | "Realtime"
                | "Hourly"
                | "EveryThreeHours"
                | "Nightly"
                | "Weekly"
                | "Monthly"
                | "Quarterly"
                | "Yearly";
              pollingFrequency: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
              serverUrl: string;
              maxRequestsPerMinute?: number;
              maxRecordsPerRequest?: number;
              adminContactEmails?: string[];
              adminNotes?: string;
              portalUrl?: string;
              webhookHash?: string;
            };
        childRecordSettings?: {
          /** @default "Off" */
          Comment: "Off" | "Push" | "TwoWay";
          /** @default "Off" */
          Attachment: "Off" | "Push" | "TwoWay";
          /** @default "Off" */
          Violation: "Off" | "Push" | "TwoWay";
          /** @default "Off" */
          Action: "Off" | "Push" | "TwoWay";
          /** @default "Off" */
          Address: "Off" | "Push" | "TwoWay";
          /** @default "Off" */
          Vehicle: "Off" | "Push" | "TwoWay";
        };
        mappings?: {
          syncType: "Pull" | "Push" | "OneTimePush";
          gogovFieldName?: string;
          externalFieldName?: string;
          externalFieldId?: string;
          externalRecordType:
            | "LucityWorkRequest"
            | "SimplicityServiceRequest"
            | "AssetEssentialsWorkOrder"
            | "EnergovCodeCase"
            | "CityViewCodeRequest"
            | "EdgesoftWorkOrder"
            | "AccelaRecord"
            | "CityWorksServiceRequest";
          mergeField?: string;
          mappingValues?: {
            id?: number;
            gogovValue?: string;
            externalValue?: string;
            gogovFieldName?: string;
            /** @format int64 */
            gogovFieldId?: number;
            externalFieldName?: string;
            externalFieldId?: string;
          }[];
          /** @format int64 */
          gogovFieldId?: number;
        }[];
        mainFilterGroup?: {
          advancedLogic?: string | null;
          filters: (
            | {
                fieldType: "Text";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "TextArea";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Number";
                integerValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Currency";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Percent";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Date";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "DateTime";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Time";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Checkbox";
                booleanValue: boolean;
                condition: "Equal" | "NotEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "SingleSelect";
                jsonValue: (string | number)[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "MultiSelect";
                jsonValue: any[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
          )[];
        };
        manualFilterGroup?: {
          advancedLogic?: string | null;
          filters: (
            | {
                fieldType: "Text";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "TextArea";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Number";
                integerValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Currency";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Percent";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Date";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "DateTime";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Time";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Checkbox";
                booleanValue: boolean;
                condition: "Equal" | "NotEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "SingleSelect";
                jsonValue: (string | number)[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "MultiSelect";
                jsonValue: any[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
          )[];
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          newIntegration?: any;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send an email to the sales team with information for customers interested in Integrations they do not have
     *
     * @tags Integrations
     * @name IntegrationsInformationCreate
     * @request POST:/core/integrations/information
     * @secure
     */
    integrationsInformationCreate: (
      data: {
        submitterFullName: string;
        submitterEmail: string;
        submitterPhoneNumber: string;
        integrationName: string;
        agencyName: string;
        agencyState: string;
        moreDetails: string;
        submitterJobTitle: string;
        submitterDepartment: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          from: string;
          to: string;
          subject: string;
          IntegrationType: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/information`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a location by id
     *
     * @tags Locations
     * @name LocationsDetail
     * @request GET:/core/locations/{id}
     * @secure
     */
    locationsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          parcelNumber: string;
          locationAddressId: number | null;
          locationName: string | null;
          ownerName: string | null;
          ownerAddressId: number | null;
          ownerEmail: string | null;
          ownerPhone: string | null;
          lotSize: number | null;
          zoning: string | null;
          yearBuilt: number | null;
          buildingTypeId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
          externalId: string | null;
          customFieldValues: {
            id: number;
            valueString: string | null;
            valueBoolean: boolean | null;
            valueInt: number | null;
            valueFloat: number | null;
            /** @format date-time */
            valueDatetime: string | null;
            valueJson?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
            valueAddressId: number | null;
            valuePicklistItemId: number | null;
            /** @format date-time */
            rowTimestamp: string;
            customFieldId: number;
            locationId: number | null;
            customField: {
              resourceType: "Location";
              type:
                | "Address"
                | "Checkbox"
                | "Currency"
                | "Date"
                | "DateTime"
                | "Dropdown"
                | "DropdownMultiSelect"
                | "Email"
                | "Number"
                | "Percent"
                | "PhoneNumber"
                | "Text"
                | "TextArea"
                | "Time"
                | "URL";
              id: number;
              cityId: number;
              resourceId: number;
              label: string;
              name: string;
              description: string;
              required: boolean;
              standardField: boolean;
              decimalPlaces: number | null;
              unit: string | null;
              picklistId: number | null;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
              picklist: {
                id: number;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                items: {
                  id: number;
                  value: string;
                  order: number;
                  picklistId: number;
                  /** @format date-time */
                  deactivatedAt: string | null;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  /** @format date-time */
                  rowTimestamp: string;
                }[];
              };
            };
            valueAddress: {
              id?: number;
              attn: string | null;
              address: string;
              address2: string | null;
              city: string;
              state: string;
              zip: string;
              /** @format date-time */
              rowTimestamp: string;
              countryId: string;
            };
            valuePicklistItem: {
              id: number;
              value: string;
              order: number;
              picklistId: number;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
            };
            valueManyPicklistItems: {
              id: number;
              coreCustomFieldValueId: number;
              corePicklistItemId: number;
              /** @format date-time */
              rowTimestamp: string;
              corePicklistItem: {
                id: number;
                value: string;
                order: number;
                picklistId: number;
                /** @format date-time */
                deactivatedAt: string | null;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                /** @format date-time */
                rowTimestamp: string;
              };
            }[];
          }[];
          locationAddress: {
            id?: number;
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            /** @format date-time */
            rowTimestamp: string;
            countryId: string;
          };
          ownerAddress: {
            id?: number;
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            /** @format date-time */
            rowTimestamp: string;
            countryId: string;
          };
          buildingType: {
            id: number;
            value: string;
            order: number;
            picklistId: number;
            /** @format date-time */
            deactivatedAt: string | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @format date-time */
            rowTimestamp: string;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/locations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a location by id
     *
     * @tags Locations
     * @name LocationsUpdate
     * @request PUT:/core/locations/{id}
     * @secure
     */
    locationsUpdate: (
      id: number,
      data: {
        parcelNumber: string;
        locationAddressId: number | null;
        locationName: string | null;
        ownerName: string | null;
        ownerAddressId: number | null;
        ownerEmail: string | null;
        ownerPhone: string | null;
        lotSize: number | null;
        zoning: string | null;
        yearBuilt: number | null;
        buildingTypeId: number | null;
        /** @format date-time */
        deactivatedAt: string | null;
        customFieldValues?: {
          valueString: string | null;
          valueBoolean: boolean | null;
          valueInt: number | null;
          valueFloat: number | null;
          /** @format date-time */
          valueDatetime: string | null;
          valueJson?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          valuePicklistItemId: number | null;
          customFieldId: number;
          valueAddress?: {
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            countryId: string;
          };
          valuePicklistItemIds: number[] | null;
        }[];
        locationAddress: {
          attn: string | null;
          address: string;
          address2: string | null;
          city: string;
          state: string;
          zip: string;
          countryId: string;
        };
        ownerAddress: {
          attn: string | null;
          address: string;
          address2: string | null;
          city: string;
          state: string;
          zip: string;
          countryId: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          parcelNumber: string;
          locationAddressId: number | null;
          locationName: string | null;
          ownerName: string | null;
          ownerAddressId: number | null;
          ownerEmail: string | null;
          ownerPhone: string | null;
          lotSize: number | null;
          zoning: string | null;
          yearBuilt: number | null;
          buildingTypeId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
          externalId: string | null;
          customFieldValues: {
            id: number;
            valueString: string | null;
            valueBoolean: boolean | null;
            valueInt: number | null;
            valueFloat: number | null;
            /** @format date-time */
            valueDatetime: string | null;
            valueJson?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
            valueAddressId: number | null;
            valuePicklistItemId: number | null;
            /** @format date-time */
            rowTimestamp: string;
            customFieldId: number;
            locationId: number | null;
            customField: {
              resourceType: "Location";
              type:
                | "Address"
                | "Checkbox"
                | "Currency"
                | "Date"
                | "DateTime"
                | "Dropdown"
                | "DropdownMultiSelect"
                | "Email"
                | "Number"
                | "Percent"
                | "PhoneNumber"
                | "Text"
                | "TextArea"
                | "Time"
                | "URL";
              id: number;
              cityId: number;
              resourceId: number;
              label: string;
              name: string;
              description: string;
              required: boolean;
              standardField: boolean;
              decimalPlaces: number | null;
              unit: string | null;
              picklistId: number | null;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
              picklist: {
                id: number;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                items: {
                  id: number;
                  value: string;
                  order: number;
                  picklistId: number;
                  /** @format date-time */
                  deactivatedAt: string | null;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  /** @format date-time */
                  rowTimestamp: string;
                }[];
              };
            };
            valueAddress: {
              id?: number;
              attn: string | null;
              address: string;
              address2: string | null;
              city: string;
              state: string;
              zip: string;
              /** @format date-time */
              rowTimestamp: string;
              countryId: string;
            };
            valuePicklistItem: {
              id: number;
              value: string;
              order: number;
              picklistId: number;
              /** @format date-time */
              deactivatedAt: string | null;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              /** @format date-time */
              rowTimestamp: string;
            };
            valueManyPicklistItems: {
              id: number;
              coreCustomFieldValueId: number;
              corePicklistItemId: number;
              /** @format date-time */
              rowTimestamp: string;
              corePicklistItem: {
                id: number;
                value: string;
                order: number;
                picklistId: number;
                /** @format date-time */
                deactivatedAt: string | null;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                /** @format date-time */
                rowTimestamp: string;
              };
            }[];
          }[];
          locationAddress: {
            id?: number;
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            /** @format date-time */
            rowTimestamp: string;
            countryId: string;
          };
          ownerAddress: {
            id?: number;
            attn: string | null;
            address: string;
            address2: string | null;
            city: string;
            state: string;
            zip: string;
            /** @format date-time */
            rowTimestamp: string;
            countryId: string;
          };
          buildingType: {
            id: number;
            value: string;
            order: number;
            picklistId: number;
            /** @format date-time */
            deactivatedAt: string | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @format date-time */
            rowTimestamp: string;
          };
        },
        | (
            | {
                statusCode: number;
                error: string;
                message: string;
                missingCustomFields?: {
                  resourceType: "Location";
                  type:
                    | "Address"
                    | "Checkbox"
                    | "Currency"
                    | "Date"
                    | "DateTime"
                    | "Dropdown"
                    | "DropdownMultiSelect"
                    | "Email"
                    | "Number"
                    | "Percent"
                    | "PhoneNumber"
                    | "Text"
                    | "TextArea"
                    | "Time"
                    | "URL";
                  id: number;
                  cityId: number;
                  resourceId: number;
                  label: string;
                  name: string;
                  description: string;
                  required: boolean;
                  standardField: boolean;
                  decimalPlaces: number | null;
                  unit: string | null;
                  picklistId: number | null;
                  /** @format date-time */
                  deactivatedAt: string | null;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  /** @format date-time */
                  rowTimestamp: string;
                }[];
                excessCustomFieldValues?: any[];
              }
            | {
                statusCode: number;
                error: string;
                message: string;
              }
          )
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/locations/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name LocationsImportStandardImportCreate
     * @request POST:/core/locations/import/standard-import
     * @secure
     */
    locationsImportStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/locations/import/standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name LocationsImportCustomImportCreate
     * @request POST:/core/locations/import/custom-import
     * @secure
     */
    locationsImportCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/locations/import/custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name LocationsImportGenerateTemplateCreate
     * @request POST:/core/locations/import/generate-template
     * @secure
     */
    locationsImportGenerateTemplateCreate: (data: any, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/core/locations/import/generate-template`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsSearchCreate
     * @request POST:/core/locations/search
     * @secure
     */
    locationsSearchCreate: (
      data: {
        query?: string;
        queryFields?: string[];
        filters?: {
          field: string;
          value: string;
        }[];
        includeDeactivated?: boolean;
        /**
         * @min 1
         * @max 150
         * @default 10
         */
        take?: number;
        cursor?: number;
        sort?: {
          field: string;
          direction: "asc" | "desc";
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/locations/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get publishing assets for a site
     *
     * @tags Mobile Publish
     * @name MobilePublishList
     * @request GET:/core/mobile/publish
     */
    mobilePublishList: (params: RequestParams = {}) =>
      this.request<
        {
          published?: string | null;
          iPhoneAppId?: string | null;
          iPhoneTeamId?: string | null;
          iPhoneTeamName?: string | null;
          iPhoneStoreIcon?: string | null;
          iPhoneStoreIconFileId?: string | null;
          iPhoneAppName?: string | null;
          iPhoneNameUnderIcon?: string | null;
          iPhoneAppDescription?: string | null;
          iPhoneKeywords?: string | null;
          iPhoneVersion?: string | null;
          iPhoneGitSha?: string | null;
          iPhoneLastError?: string | null;
          androidAppId?: string | null;
          androidPromotionGraphic?: string | null;
          androidFeatureGraphic?: string | null;
          androidFeatureGraphicFileId?: string | null;
          androidPromoText?: string | null;
          androidVersion?: string | null;
          androidGitSha?: string | null;
          androidLegacyKey?: string | null;
          androidSigningSha1?: string | null;
          androidSigningSha256?: string | null;
          androidLastError?: string | null;
          firebaseProjectName?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          submittedAt?: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/mobile/publish`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set publishing assets for a site
     *
     * @tags Mobile Publish
     * @name MobilePublishUpdate
     * @request PUT:/core/mobile/publish
     * @secure
     */
    mobilePublishUpdate: (
      data: {
        published?: string | null;
        iPhoneAppId?: string | null;
        iPhoneTeamId?: string | null;
        iPhoneTeamName?: string | null;
        iPhoneStoreIcon?: string | null;
        iPhoneStoreIconFileId?: string | null;
        iPhoneAppName?: string | null;
        iPhoneNameUnderIcon?: string | null;
        iPhoneAppDescription?: string | null;
        iPhoneKeywords?: string | null;
        iPhoneVersion?: string | null;
        iPhoneGitSha?: string | null;
        iPhoneLastError?: string | null;
        androidAppId?: string | null;
        androidPromotionGraphic?: string | null;
        androidFeatureGraphic?: string | null;
        androidFeatureGraphicFileId?: string | null;
        androidPromoText?: string | null;
        androidVersion?: string | null;
        androidGitSha?: string | null;
        androidLegacyKey?: string | null;
        androidSigningSha1?: string | null;
        androidSigningSha256?: string | null;
        androidLastError?: string | null;
        firebaseProjectName?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        submittedAt?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/mobile/publish`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get branding assets for a site
     *
     * @tags Mobile Branding
     * @name MobileBrandingList
     * @request GET:/core/mobile/branding
     * @secure
     */
    mobileBrandingList: (params: RequestParams = {}) =>
      this.request<
        {
          banner: string | null;
          logo: string | null;
          color: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/mobile/branding`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Set branding assets for a site
     *
     * @tags Mobile Branding
     * @name MobileBrandingUpdate
     * @request PUT:/core/mobile/branding
     * @secure
     */
    mobileBrandingUpdate: (
      data: {
        bannerFileId: string | null;
        logoFileId: string | null;
        color: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/mobile/branding`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send an invite SMS to a user (rate limited to 1 call per minute)
     *
     * @tags Notify
     * @name NotifyInviteCreate
     * @request POST:/core/notify/invite
     */
    notifyInviteCreate: (
      data: {
        phoneNumber: string;
        /** @default false */
        forceVoice?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | {
            statusCode: number;
            error: string;
            message: string;
            validationErrors: string[];
          }
        | {
            statusCode: number;
            error: string;
            message: string;
            code: "PHONE_NUMBER_OPTED_OUT";
          }
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
      >({
        path: `/core/notify/invite`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send a batch of push notifications
     *
     * @tags Notify
     * @name NotifyPushNotificationCreate
     * @request POST:/core/notify/push-notification
     * @secure
     */
    notifyPushNotificationCreate: (
      data: {
        /**
         * @maxItems 500
         * @minItems 1
         */
        messages: {
          title?: string;
          body: string;
          token: string;
          data?: Record<string, any>;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          totalSuccessful: number;
          totalFailed: number;
          failedMessages: {
            token: string;
            error?: {
              code: string;
              message: string;
            };
            personId?: number;
          }[];
          totalStale: number;
          staleMessages: {
            token: string;
            error?: {
              code: string;
              message: string;
            };
            personId?: number;
          }[];
          totalFailedNonStaleMessages: number;
          failedNonStaleMessages: {
            token: string;
            error?: {
              code: string;
              message: string;
            };
            personId?: number;
          }[];
        },
        | {
            statusCode: number;
            error: string;
            message: string;
          }
        | {
            totalSuccessful: number;
            totalFailed: number;
            failedMessages: {
              token: string;
              error?: {
                code: string;
                message: string;
              };
              personId?: number;
            }[];
            totalStale: number;
            staleMessages: {
              token: string;
              error?: {
                code: string;
                message: string;
              };
              personId?: number;
            }[];
            totalFailedNonStaleMessages: number;
            failedNonStaleMessages: {
              token: string;
              error?: {
                code: string;
                message: string;
              };
              personId?: number;
            }[];
          }
      >({
        path: `/core/notify/push-notification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notify
     * @name NotifySettingsList
     * @request GET:/core/notify/settings
     * @secure
     */
    notifySettingsList: (params: RequestParams = {}) =>
      this.request<
        {
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          suspendedAt: string | null;
          twilioAccountSid: string;
          smsBrandName: string;
          smsTwilioMessagingServiceSid: string;
          voiceBrandName: string;
          voiceTextToSpeechVoice: "AWSPollyGenerativeRuth" | "AWSPollyGenerativeMatthew";
          voiceTwilioPhoneNumberSid: string;
          voiceTwilioPhoneNumber: string;
          voiceDictionaryRules: {
            find: string;
            replace: string;
            isGlobal: boolean;
          }[];
          billingAccountId: number;
          smsPreviewInviteMessage: string;
          smsPreviewWelcomeMessage: string;
          smsPreviewNotificationMessage: string;
          availableCredits: number;
        },
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/notify/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the SMS Settings for a site
     *
     * @tags Notify
     * @name NotifySettingsUpdate
     * @request PUT:/core/notify/settings
     * @secure
     */
    notifySettingsUpdate: (
      data: {
        /** @maxLength 191 */
        twilioAccountSid: string;
        /** @maxLength 25 */
        smsBrandName: string;
        /** @maxLength 191 */
        smsTwilioMessagingServiceSid: string;
        /** @maxLength 25 */
        voiceBrandName: string;
        voiceTextToSpeechVoice: "AWSPollyGenerativeRuth" | "AWSPollyGenerativeMatthew";
        /** @maxLength 191 */
        voiceTwilioPhoneNumberSid: string;
        voiceDictionaryRules: {
          /** @maxLength 191 */
          find: string;
          /** @maxLength 191 */
          replace: string;
          isGlobal?: boolean;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          suspendedAt: string | null;
          twilioAccountSid: string;
          smsBrandName: string;
          smsTwilioMessagingServiceSid: string;
          voiceBrandName: string;
          voiceTextToSpeechVoice: "AWSPollyGenerativeRuth" | "AWSPollyGenerativeMatthew";
          voiceTwilioPhoneNumberSid: string;
          voiceTwilioPhoneNumber: string;
          voiceDictionaryRules: {
            find: string;
            replace: string;
            isGlobal: boolean;
          }[];
          billingAccountId: number;
        },
        | {
            statusCode: number;
            error: string;
            message: string;
            validationErrors: string[];
          }
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
      >({
        path: `/core/notify/settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all subscription groups
     *
     * @tags Notify
     * @name NotifySubscriptionGroupList
     * @request GET:/core/notify/subscription-group
     * @secure
     */
    notifySubscriptionGroupList: (
      query?: {
        cursor?: number;
        /**
         * @min 1
         * @exclusiveMin true
         * @max 500
         */
        take?: number;
        /** @default "false" */
        includeDeactivated?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          autoSubscribe: boolean;
          visibility: "Public" | "Unlisted" | "Private";
          description: string | null;
        }[],
        any
      >({
        path: `/core/notify/subscription-group`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a subscription group
     *
     * @tags Notify
     * @name NotifySubscriptionGroupCreate
     * @request POST:/core/notify/subscription-group
     * @secure
     */
    notifySubscriptionGroupCreate: (
      data: {
        /** @maxLength 191 */
        name: string;
        autoSubscribe: boolean;
        visibility: "Public" | "Unlisted" | "Private";
        /** @maxLength 191 */
        description: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          autoSubscribe: boolean;
          visibility: "Public" | "Unlisted" | "Private";
          description: string | null;
        },
        any
      >({
        path: `/core/notify/subscription-group`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name PermitsImportStandardImportCreate
     * @request POST:/core/permits/import/standard-import
     * @secure
     */
    permitsImportStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/permits/import/standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name PermitsImportCustomImportCreate
     * @request POST:/core/permits/import/custom-import
     * @secure
     */
    permitsImportCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/permits/import/custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name PermitsImportAttachmentsStandardImportCreate
     * @request POST:/core/permits/import/attachments-standard-import
     * @secure
     */
    permitsImportAttachmentsStandardImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/permits/import/attachments-standard-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name PermitsImportAttachmentsCustomImportCreate
     * @request POST:/core/permits/import/attachments-custom-import
     * @secure
     */
    permitsImportAttachmentsCustomImportCreate: (
      data: {
        /** @minLength 1 */
        s3url: string;
        /** @minLength 1 */
        s3bucket: string;
        /** @minLength 1 */
        s3key: string;
        /** @minLength 1 */
        originalFileName: string;
        /** @minLength 1 */
        name: string;
        /** @minLength 1 */
        projectName: string;
        /** @minLength 1 */
        importType: string;
        readonly: boolean;
        /** @format email */
        emailResultsTo?: string;
        /** @default false */
        deactivateOldRecords?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/permits/import/attachments-custom-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get array of JSON objects with agency app ids and links that can be opened in mobile apps
     *
     * @tags Agency
     * @name AgencySettingsAppleAppStoreAssociationList
     * @request GET:/core/agency/settings/apple-app-store-association
     */
    agencySettingsAppleAppStoreAssociationList: (params: RequestParams = {}) =>
      this.request<
        {
          applinks: {
            details: {
              appID: string;
              components: {
                "/": string;
                comment: string;
              }[];
            }[];
          };
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/agency/settings/apple-app-store-association`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves country data (states, postal code format, iso2, etc.) for an agency's country.
     *
     * @tags Agency
     * @name AgencySettingsCountryList
     * @summary Retrieve country for agency
     * @request GET:/core/agency/settings/country
     */
    agencySettingsCountryList: (params: RequestParams = {}) =>
      this.request<
        {
          id: string;
          countryName: string;
          callingCode: string;
          iso3: string;
          postalFirst: boolean;
          hasStateInAddress: boolean;
          postalFormat: string | null;
          states: string[] | null;
        },
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            error: string;
          }
      >({
        path: `/core/agency/settings/country`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get array of JSON objects with agency app ids and SHA-256 signing.
     *
     * @tags Agency
     * @name AgencySettingsDigitalAssetLinksList
     * @request GET:/core/agency/settings/digital-asset-links
     */
    agencySettingsDigitalAssetLinksList: (params: RequestParams = {}) =>
      this.request<
        {
          relation: string[];
          target: {
            namespace: string;
            package_name: string;
            sha256_cert_fingerprints: string[];
          };
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/agency/settings/digital-asset-links`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get an agency's general settings
     *
     * @tags Agency
     * @name AgencySettingsGeneralSettingsList
     * @request GET:/core/agency/settings/general-settings
     * @secure
     */
    agencySettingsGeneralSettingsList: (params: RequestParams = {}) =>
      this.request<
        {
          data: {
            attributes: {
              seal: {
                url: string | null;
              };
              countryId: string;
              timezone: string;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/agency/settings/general-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update agency's general settings.
     *
     * @tags Agency
     * @name AgencySettingsGeneralSettingsUpdate
     * @request PUT:/core/agency/settings/general-settings
     * @secure
     */
    agencySettingsGeneralSettingsUpdate: (
      data: {
        sealFileId?: string;
        countryId?: string;
        timezone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            attributes: {
              seal: {
                url: string | null;
              };
              countryId: string;
              timezone: string;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/agency/settings/general-settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the well known Microsoft Application IDs associated with core
     *
     * @tags Agency
     * @name AgencySettingsMicrosoftIdentityAssociationList
     * @request GET:/core/agency/settings/microsoft-identity-association
     */
    agencySettingsMicrosoftIdentityAssociationList: (params: RequestParams = {}) =>
      this.request<
        {
          associatedApplications: {
            applicationId: string;
          }[];
        },
        any
      >({
        path: `/core/agency/settings/microsoft-identity-association`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Gets the picklist items for a given 'pick-name'. This is a legacy thing.
     *
     * @tags Agency
     * @name AgencyPicklistDetail
     * @summary Get pick-list items
     * @request GET:/core/agency/picklist/{pickName}
     * @secure
     */
    agencyPicklistDetail: (pickName: string, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            pickList: {
              pickId: number;
              cityId: number;
              pickName: string;
              pickValue: string;
              pickOrder: number;
            }[];
          };
        },
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: 404;
            message: "Not Found";
            error: string;
          }
      >({
        path: `/core/agency/picklist/${pickName}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get agency's mapping between Location custom fields and CE custom fields.
     *
     * @tags CE
     * @name CeGeneralSettingsLocationMappingList
     * @request GET:/core/ce/general-settings/location-mapping
     * @secure
     */
    ceGeneralSettingsLocationMappingList: (params: RequestParams = {}) =>
      this.request<
        {
          targetedCEField:
            | "PropertyAlert"
            | "PropertyOccupant"
            | "PropertyPhone"
            | "PropertyCell"
            | "PropertyEmail"
            | "EnforceZone"
            | "PropertyStatus"
            | "Subdivision"
            | "Classification"
            | "SubClassification"
            | "Flag1"
            | "Flag2"
            | "Flag3"
            | "Flag4"
            | null;
          id: number;
          cityId: number;
          locationCustomFieldId: number;
          ceCaseExtensionDefId: number | null;
          CoreCustomField: {
            resourceType: "Location";
            type:
              | "Address"
              | "Checkbox"
              | "Currency"
              | "Date"
              | "DateTime"
              | "Dropdown"
              | "DropdownMultiSelect"
              | "Email"
              | "Number"
              | "Percent"
              | "PhoneNumber"
              | "Text"
              | "TextArea"
              | "Time"
              | "URL";
            id: number;
            cityId: number;
            resourceId: number;
            label: string;
            name: string;
            description: string;
            required: boolean;
            standardField: boolean;
            decimalPlaces: number | null;
            unit: string | null;
            picklistId: number | null;
            /** @format date-time */
            deactivatedAt: string | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @format date-time */
            rowTimestamp: string;
          };
          CECaseExtensionDef: {
            caseExtensionId: number;
            cityId: number;
            fieldName: string;
            defaultValue: string;
            requiredMsg: string;
            /** @format date-time */
            rowTimestamp: string;
          } | null;
        }[],
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/ce/general-settings/location-mapping`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CE Letters
     * @name CeLettersDetail
     * @request GET:/core/ce/letters/{id}
     * @secure
     */
    ceLettersDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: string;
            attributes: {
              "content-url": string | null;
            };
          };
        },
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/ce/letters/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deactivate a custom field, will throw 400 if field is a standard field
     *
     * @tags Custom Fields
     * @name CustomFieldsDeactivatedUpdate
     * @request PUT:/core/custom-fields/{id}/deactivated
     * @secure
     */
    customFieldsDeactivatedUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          resourceType: "Location";
          type:
            | "Address"
            | "Checkbox"
            | "Currency"
            | "Date"
            | "DateTime"
            | "Dropdown"
            | "DropdownMultiSelect"
            | "Email"
            | "Number"
            | "Percent"
            | "PhoneNumber"
            | "Text"
            | "TextArea"
            | "Time"
            | "URL";
          id: number;
          cityId: number;
          resourceId: number;
          label: string;
          name: string;
          description: string;
          required: boolean;
          standardField: boolean;
          decimalPlaces: number | null;
          unit: string | null;
          picklistId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/custom-fields/${id}/deactivated`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reactivate a custom field
     *
     * @tags Custom Fields
     * @name CustomFieldsDeactivatedDelete
     * @request DELETE:/core/custom-fields/{id}/deactivated
     * @secure
     */
    customFieldsDeactivatedDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          resourceType: "Location";
          type:
            | "Address"
            | "Checkbox"
            | "Currency"
            | "Date"
            | "DateTime"
            | "Dropdown"
            | "DropdownMultiSelect"
            | "Email"
            | "Number"
            | "Percent"
            | "PhoneNumber"
            | "Text"
            | "TextArea"
            | "Time"
            | "URL";
          id: number;
          cityId: number;
          resourceId: number;
          label: string;
          name: string;
          description: string;
          required: boolean;
          standardField: boolean;
          decimalPlaces: number | null;
          unit: string | null;
          picklistId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
        },
        any
      >({
        path: `/core/custom-fields/${id}/deactivated`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Download a document by id
     *
     * @tags Documents
     * @name DocumentsDownloadDetail
     * @request GET:/core/documents/{id}/download
     * @secure
     */
    documentsDownloadDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          signedUrl: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/${id}/download`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsGenerateBulkCreate
     * @request POST:/core/documents/generate/bulk
     * @secure
     */
    documentsGenerateBulkCreate: (
      data: {
        /** @default true */
        concatenateDocuments?: boolean;
        /** @default false */
        issueDocuments?: boolean;
        onIssuedCallbackURL?: string;
        /** The user id performing the document generation task, only required for service-to-service calls */
        userId?: number | null;
        backgroundJobId?: number | null;
        documents: {
          templateId: number;
          resourceType?: "Permit" | "PermitsStep";
          resourceId?: number;
          context: (string | number | boolean | "null" | null) | any[] | Record<string, any>;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/generate/bulk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsGeneratePreviewCreate
     * @request POST:/core/documents/generate/preview
     * @secure
     */
    documentsGeneratePreviewCreate: (
      data: {
        templateId: number;
        context: (string | number | boolean | "null" | null) | any[] | Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          s3SignedUrl: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/generate/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsGenerateTestCreate
     * @request POST:/core/documents/generate/test
     * @secure
     */
    documentsGenerateTestCreate: (
      data: {
        document: {
          templateS3Object: {
            bucket: string;
            key: string;
          };
          resourceType: "Permit" | "PermitsStep";
          resourceId: number;
          context: (string | number | boolean | "null" | null) | any[] | Record<string, any>;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          status: "Pending" | "Running" | "Completed" | "Errored" | "Cancelled";
          id: number;
          cityId: number;
          userId: number | null;
          emailResultsTo: string | null;
          name: string;
          jobType: string;
          isTest: boolean;
          stepCurrent: number;
          stepTotal: number;
          stepProgressMessage: string | null;
          progressPercentage: number;
          progressMessage: string | null;
          recordsTotal: number;
          recordsProcessed: number;
          jobDetails?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          errorCount: number;
          s3ResultsKey: string | null;
          results?: (string | number | boolean | any[] | Record<string, any>) | "DbNull" | "JsonNull" | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          endedAt: string | null;
          /** @format date-time */
          cancelRequestedAt: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/generate/test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a document template by id
     *
     * @tags Documents
     * @name DocumentsTemplatesDetail
     * @request GET:/core/documents/templates/{id}
     * @secure
     */
    documentsTemplatesDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          resourceType: "Permits";
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          description: string | null;
          s3Url: string | null;
          isPublic: boolean | null;
          manyDocumentSubTypes?: {
            id: number;
            documentsTemplateId: number;
            permitsTypeId: number;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/templates/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a document template by id
     *
     * @tags Documents
     * @name DocumentsTemplatesUpdate
     * @request PUT:/core/documents/templates/{id}
     * @secure
     */
    documentsTemplatesUpdate: (
      id: number,
      data: {
        resourceType: "Permits";
        description: string | null;
        name: string | null;
        documentSubTypes?: {
          permitsTypeId: number;
        }[];
      } & (
        | {
            s3url: string;
            s3bucket: string;
            s3key: string;
          }
        | {
            s3url?: any;
            s3bucket?: any;
            s3key?: any;
          }
      ),
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resourceType: "Permits";
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          description: string | null;
          s3Url: string | null;
          isPublic: boolean | null;
          manyDocumentSubTypes?: {
            id: number;
            documentsTemplateId: number;
            permitsTypeId: number;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/templates/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates file metadata after file upload
     *
     * @tags File Upload
     * @name FileFinalizedCreate
     * @request POST:/core/file/{id}/finalized
     * @secure
     */
    fileFinalizedCreate: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          url: string;
          file: {
            id: number;
            cityId: number;
            uuid: string;
            usage:
              | "Permits"
              | "CE"
              | "CRM"
              | "InspectionItemCommentAttachments"
              | "InspectionAttachmentVideoOriginal"
              | "SiteAssets"
              | "NotifyVoiceResources";
            s3Key: string;
            bucket: string;
            s3StorageClass: string | null;
            status: "New" | "Temp" | "Committed" | "Archived";
            sizeInBytes: number | null;
            originalFileName: string;
            fileExtension: string;
            /** @format date-time */
            fileUpdatedAt: string | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @format date-time */
            deleteRequestedAt: string | null;
            /** @format date-time */
            deletedAt: string | null;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/file/${id}/finalized`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get progress of video processing
     *
     * @tags Video Processing
     * @name FileVideoDetail
     * @request GET:/core/file/{id}/video
     * @secure
     */
    fileVideoDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          url: string | null;
          status: "Pending" | "Running" | "Complete" | "Error" | null;
          progress: number | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/file/${id}/video`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an inspection's address by id
     *
     * @tags Inspections
     * @name InspectionsAddressPartialUpdate
     * @request PATCH:/core/inspections/{id}/address
     * @secure
     */
    inspectionsAddressPartialUpdate: (
      id: number,
      data: {
        data: {
          address: {
            attn?: string;
            address: string;
            address2?: string;
            city: string;
            /** @maxLength 3 */
            state: string;
            zip: string;
            /** @default "US" */
            countryId?: string;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            address?: {
              attn?: string | null;
              address: string;
              address2?: string | null;
              city: string;
              state: string;
              zip: string;
              countryId: string;
              /** @format date-time */
              rowTimestamp: string;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/address`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fail an inspection by id
     *
     * @tags Inspections
     * @name InspectionsFailUpdate
     * @request PUT:/core/inspections/{id}/fail
     * @secure
     */
    inspectionsFailUpdate: (
      id: number,
      data: {
        data: {
          attributes: {
            comment: string;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/fail`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an inspections on-site contact info by id
     *
     * @tags Inspections
     * @name InspectionsOnSiteContactInfoUpdate
     * @request PUT:/core/inspections/{id}/on-site-contact-info
     * @secure
     */
    inspectionsOnSiteContactInfoUpdate: (
      id: number,
      data: {
        onSiteContactName?: string;
        onSiteContactInstructions?: string;
        onSiteContactPhone?: string;
        onSiteContactApplicantInstructions?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/on-site-contact-info`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Pass an inspection by id
     *
     * @tags Inspections
     * @name InspectionsPassUpdate
     * @request PUT:/core/inspections/{id}/pass
     * @secure
     */
    inspectionsPassUpdate: (
      id: number,
      data: {
        data: {
          attributes: {
            comment: string;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/pass`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all previous inspections for a given re-inspection
     *
     * @tags Inspections
     * @name InspectionsPreviousInspectionsDetail
     * @request GET:/core/inspections/{id}/previous-inspections
     * @secure
     */
    inspectionsPreviousInspectionsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/previous-inspections`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an inspections primary location
     *
     * @tags Inspections
     * @name InspectionsPrimaryLocationPartialUpdate
     * @request PATCH:/core/inspections/{id}/primary-location
     * @secure
     */
    inspectionsPrimaryLocationPartialUpdate: (
      id: number,
      data: {
        data: {
          primaryLocationId: number;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/primary-location`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Schedule an inspection
     *
     * @tags Inspections
     * @name InspectionsScheduleUpdate
     * @request PUT:/core/inspections/{id}/schedule
     * @secure
     */
    inspectionsScheduleUpdate: (
      id: number,
      data: {
        data: {
          attributes: {
            "scheduled-date"?: string | null;
            "scheduled-time"?: string | null;
            "scheduled-meridiem"?: string;
            "assignee-id"?: number;
            "on-site-contact-name"?: string;
            "on-site-contact-phone"?: string;
            "on-site-contact-instructions"?: string;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              "inspections-types-id": number;
              status: string | null;
              comment: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              assignee?: any;
              "assignee-id": number | null;
              applicant?: any;
              "applicant-id": number | null;
              "inspectable-type": string | null;
              "inspectable-id": number;
              "record-id": number | null;
              "record-type": string | null;
              "record-name": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              onSiteContactInstructions?: string | null;
              onSiteContactApplicantInstructions?: string | null;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              parentId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/schedule`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the schedule for an inspection
     *
     * @tags Inspections
     * @name InspectionsScheduleDetail
     * @request GET:/core/inspections/{id}/schedule
     * @secure
     */
    inspectionsScheduleDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          schedule: Record<
            string,
            Record<
              string,
              {
                AM: number;
                PM: number;
              }
            >
          >;
          inspectors: {
            id: number;
            firstName?: string;
            lastName?: string;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/schedule`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an inspections schedule-at date
     *
     * @tags Inspections
     * @name InspectionsScheduledAtDelete
     * @request DELETE:/core/inspections/{id}/scheduled-at
     * @secure
     */
    inspectionsScheduledAtDelete: (id: number, data: object, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            message: string;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/scheduled-at`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Schedule an inspection
     *
     * @tags Inspections
     * @name InspectionsStartedAtCreate
     * @request POST:/core/inspections/{id}/started-at
     * @secure
     */
    inspectionsStartedAtCreate: (id: number, data: object, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            /** @format date-time */
            startedAt?: string | null;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/started-at`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Gets the public/citizen version of an inspection
     *
     * @tags Inspections
     * @name InspectionsPublicDetail
     * @request GET:/core/inspections/public/{id}
     * @secure
     */
    inspectionsPublicDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              status: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              comment: string | null;
              applicant?: any;
              assignee?: any;
              "record-id": number | null;
              inspectable_type: string | null;
              inspectable_id: number;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              onSiteContactApplicantInstructions?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              reInspection: {
                id: number;
                status: string;
              } | null;
              previousInspectionId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/public/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get an inspection-type by its id
     *
     * @tags Inspections
     * @name InspectionsTypesDetail
     * @request GET:/core/inspections/types/{id}
     * @secure
     */
    inspectionsTypesDetail: (
      id: number,
      query?: {
        deleted?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspections-type";
            attributes: {
              title: string;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              /** @format date-time */
              "deactivated-at": string | null;
            };
            relationships: {
              sections: {
                data: {
                  id: string;
                  type: "section";
                }[];
              };
            };
          };
          included: {
            id: string;
            type: "section";
            attributes: {
              title: string;
              order: number;
              "inspections-type-id": number | null;
              items: {
                id: number;
                title: string;
                type: string | null;
                order: number;
                inspections_types_section_id: number;
                /** @format date-time */
                created_at: string;
                /** @format date-time */
                updated_at: string;
                description: string | null;
                /** @format date-time */
                deleted_at: string | null;
              }[];
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an inspection-type by id
     *
     * @tags Inspections
     * @name InspectionsTypesUpdate
     * @request PUT:/core/inspections/types/{id}
     * @secure
     */
    inspectionsTypesUpdate: (
      id: number,
      data: {
        data: {
          attributes: {
            title: string;
            citizenHelpText?: string;
            blockOutDays?: string[];
            sections_attributes?: (
              | {
                  id: string;
                  _destroy?: boolean;
                  title: string;
                  items_attributes?: (
                    | {
                        /** @maxLength 1000 */
                        description?: string | null;
                        /** @maxLength 255 */
                        title: string;
                        id: number;
                        _destroy?: boolean;
                      }
                    | {
                        /** @maxLength 1000 */
                        description?: string | null;
                        /** @maxLength 255 */
                        title: string;
                      }
                  )[];
                }
              | {
                  title: string;
                  items_attributes?: (
                    | {
                        /** @maxLength 1000 */
                        description?: string | null;
                        /** @maxLength 255 */
                        title: string;
                        id: number;
                        _destroy?: boolean;
                      }
                    | {
                        /** @maxLength 1000 */
                        description?: string | null;
                        /** @maxLength 255 */
                        title: string;
                      }
                  )[];
                }
            )[];
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspections-type";
            attributes: {
              title: string;
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              /** @format date-time */
              "deactivated-at": string | null;
            };
            relationships: {
              sections: {
                data: {
                  id: string;
                  type: "section";
                }[];
              };
            };
          };
          included: {
            id: string;
            type: "section";
            attributes: {
              title: string;
              order: number;
              "inspections-type-id": number | null;
              items: {
                id: number;
                title: string;
                type: string | null;
                order: number;
                inspections_types_section_id: number;
                /** @format date-time */
                created_at: string;
                /** @format date-time */
                updated_at: string;
                description: string | null;
                /** @format date-time */
                deleted_at: string | null;
              }[];
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a data sync integration.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncUpdate
     * @request PUT:/core/integrations/data-sync/{id}
     * @secure
     */
    integrationsDataSyncUpdate: (
      id: number,
      data: {
        settings?:
          | {
              authType: "Anonymous";
              name?: string;
              productType?: "CRM" | "CE" | "Notify" | "Permits";
              integrationType?:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              externalRecordType?:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              dynamicExternalRecordType?: string;
              syncingFrequency?:
                | "Realtime"
                | "Hourly"
                | "EveryThreeHours"
                | "Nightly"
                | "Weekly"
                | "Monthly"
                | "Quarterly"
                | "Yearly";
              pollingFrequency?: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
              serverUrl?: string;
              maxRequestsPerMinute?: number;
              maxRecordsPerRequest?: number;
              adminContactEmails?: string[];
              adminNotes?: string;
              portalUrl?: string;
              webhookHash?: string;
            }
          | {
              authType: "Authenticated";
              /** @minLength 1 */
              authPassword?: string;
              authUser?: string;
              name?: string;
              productType?: "CRM" | "CE" | "Notify" | "Permits";
              integrationType?:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              externalRecordType?:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              dynamicExternalRecordType?: string;
              syncingFrequency?:
                | "Realtime"
                | "Hourly"
                | "EveryThreeHours"
                | "Nightly"
                | "Weekly"
                | "Monthly"
                | "Quarterly"
                | "Yearly";
              pollingFrequency?: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
              serverUrl?: string;
              maxRequestsPerMinute?: number;
              maxRecordsPerRequest?: number;
              adminContactEmails?: string[];
              adminNotes?: string;
              portalUrl?: string;
              webhookHash?: string;
            }
          | {
              authType: "ApiKey";
              apiKey: string;
              name?: string;
              productType?: "CRM" | "CE" | "Notify" | "Permits";
              integrationType?:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              externalRecordType?:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              dynamicExternalRecordType?: string;
              syncingFrequency?:
                | "Realtime"
                | "Hourly"
                | "EveryThreeHours"
                | "Nightly"
                | "Weekly"
                | "Monthly"
                | "Quarterly"
                | "Yearly";
              pollingFrequency?: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
              serverUrl?: string;
              maxRequestsPerMinute?: number;
              maxRecordsPerRequest?: number;
              adminContactEmails?: string[];
              adminNotes?: string;
              portalUrl?: string;
              webhookHash?: string;
            }
          | {
              authType?: any;
              name?: string;
              productType?: "CRM" | "CE" | "Notify" | "Permits";
              integrationType?:
                | "Lucity"
                | "Simplicity"
                | "CityView"
                | "Energov"
                | "Cartegraph"
                | "AssetEssentials"
                | "CityWorks"
                | "Accela"
                | "Edgesoft";
              externalRecordType?:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              dynamicExternalRecordType?: string;
              syncingFrequency?:
                | "Realtime"
                | "Hourly"
                | "EveryThreeHours"
                | "Nightly"
                | "Weekly"
                | "Monthly"
                | "Quarterly"
                | "Yearly";
              pollingFrequency?: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
              serverUrl?: string;
              maxRequestsPerMinute?: number;
              maxRecordsPerRequest?: number;
              adminContactEmails?: string[];
              adminNotes?: string;
              portalUrl?: string;
              webhookHash?: string;
            };
        childRecordSettings?: {
          create?: {
            childRecordType: "Comment" | "Attachment" | "Violation" | "Action" | "Address" | "Vehicle";
            /** @default "Off" */
            setting?: "Off" | "Push" | "TwoWay";
          }[];
          update?: {
            id: number;
            childRecordType: "Comment" | "Attachment" | "Violation" | "Action" | "Address" | "Vehicle";
            /** @default "Off" */
            setting?: "Off" | "Push" | "TwoWay";
          }[];
          delete?: number[];
        };
        mappings?: {
          create?: {
            syncType: "Pull" | "Push" | "OneTimePush";
            gogovFieldName?: string;
            externalFieldName?: string;
            externalFieldId?: string;
            externalRecordType:
              | "LucityWorkRequest"
              | "SimplicityServiceRequest"
              | "AssetEssentialsWorkOrder"
              | "EnergovCodeCase"
              | "CityViewCodeRequest"
              | "EdgesoftWorkOrder"
              | "AccelaRecord"
              | "CityWorksServiceRequest";
            mergeField?: string;
            mappingValues?: {
              id?: number;
              gogovValue?: string;
              externalValue?: string;
              gogovFieldName?: string;
              /** @format int64 */
              gogovFieldId?: number;
              externalFieldName?: string;
              externalFieldId?: string;
            }[];
            /** @format int64 */
            gogovFieldId?: number;
          }[];
          update?: {
            syncType: "Pull" | "Push" | "OneTimePush";
            gogovFieldName?: string;
            externalFieldName?: string;
            externalFieldId?: string;
            mergeField?: string;
            /** @format int64 */
            gogovFieldId?: number;
            id: number;
            mappingValues: {
              create?: {
                gogovValue?: string;
                externalValue?: string;
                gogovFieldName?: string;
                externalFieldName?: string;
                externalFieldId?: string;
                /** @format int64 */
                gogovFieldId?: number;
              }[];
              update?: {
                gogovValue?: string;
                externalValue?: string;
                gogovFieldName?: string;
                externalFieldName?: string;
                externalFieldId?: string;
                /** @format int64 */
                gogovFieldId?: number;
                id: number;
              }[];
              delete?: number[];
            };
          }[];
          delete?: number[];
        };
        mainFilterGroup?: {
          advancedLogic?: string | null;
          id?: number;
          create?: (
            | {
                fieldType: "Text";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "TextArea";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Number";
                integerValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Currency";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Percent";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Date";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "DateTime";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Time";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Checkbox";
                booleanValue: boolean;
                condition: "Equal" | "NotEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "SingleSelect";
                jsonValue: (string | number)[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "MultiSelect";
                jsonValue: any[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
          )[];
          update?: (
            | {
                fieldType: "Text";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "TextArea";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Number";
                integerValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Currency";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Percent";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Date";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "IsBeforeOrEqual"
                  | "IsAfterOrEqual"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "DateTime";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "IsBeforeOrEqual"
                  | "IsAfterOrEqual"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Time";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "IsBeforeOrEqual"
                  | "IsAfterOrEqual"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Checkbox";
                booleanValue: boolean;
                condition: "Equal" | "NotEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "SingleSelect";
                jsonValue: (string | number)[];
                condition: "Any" | "NotAny";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "MultiSelect";
                jsonValue: any[];
                condition: "Any" | "NotAny";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
          )[];
          delete?: number[];
        };
        manualFilterGroup?: {
          advancedLogic?: string | null;
          id?: number;
          create?: (
            | {
                fieldType: "Text";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "TextArea";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Number";
                integerValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Currency";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Percent";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Date";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "DateTime";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Time";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Checkbox";
                booleanValue: boolean;
                condition: "Equal" | "NotEqual";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "SingleSelect";
                jsonValue: (string | number)[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "MultiSelect";
                jsonValue: any[];
                condition: "Any" | "NotAny";
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
          )[];
          update?: (
            | {
                fieldType: "Text";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "TextArea";
                stringValue: string;
                condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Number";
                integerValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Currency";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Percent";
                floatValue: number;
                condition: "Equal" | "NotEqual" | "GreaterThan" | "LessThan" | "GreaterThanOrEqual" | "LessThanOrEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Date";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "IsBeforeOrEqual"
                  | "IsAfterOrEqual"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "DateTime";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "IsBeforeOrEqual"
                  | "IsAfterOrEqual"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Time";
                /** @format date-time */
                dateValue?: string | null;
                integerValue?: number | null;
                condition:
                  | "Equal"
                  | "NotEqual"
                  | "IsBefore"
                  | "IsAfter"
                  | "IsBeforeOrEqual"
                  | "IsAfterOrEqual"
                  | "CurrentDay"
                  | "CurrentWeek"
                  | "CurrentMonth"
                  | "DaysAgo"
                  | "WeeksAgo"
                  | "MonthsAgo"
                  | "YearsAgo"
                  | "DaysAhead"
                  | "WeeksAhead"
                  | "MonthsAhead"
                  | "YearsAhead";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "Checkbox";
                booleanValue: boolean;
                condition: "Equal" | "NotEqual";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "SingleSelect";
                jsonValue: (string | number)[];
                condition: "Any" | "NotAny";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
            | {
                fieldType: "MultiSelect";
                jsonValue: any[];
                condition: "Any" | "NotAny";
                id?: number;
                order: number;
                field: string;
                fieldId?: number | null;
                fieldTable?: string | null;
              }
          )[];
          delete?: number[];
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Hard delete a data sync integration. WARNING, THIS IS NOT THE SAME AS DEACTIVATING.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncDelete
     * @request DELETE:/core/integrations/data-sync/{id}
     * @secure
     */
    integrationsDataSyncDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a data sync integration.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncDetail
     * @request GET:/core/integrations/data-sync/{id}
     * @secure
     */
    integrationsDataSyncDetail: (
      id: number,
      query?: {
        /** @default false */
        enabledOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          gogovCapabilities?: {
            Comment: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Attachment: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Violation: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Action: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Address: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Vehicle: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
          };
          externalCapabilities: {
            LucityWorkRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            SimplicityServiceRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            AssetEssentialsWorkOrder: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            EnergovCodeCase: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            CityViewCodeRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            EdgesoftWorkOrder: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            AccelaRecord: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            CityWorksServiceRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
          };
          gogovFields: {
            formalName: string;
            gogovFieldName: string;
            mappingValues?: {
              gogovValue: string;
              formalName?: string;
            }[];
            allowedSyncTypes: ("Pull" | "Push" | "OneTimePush")[];
            filterOptions?: {
              fieldType:
                | "Text"
                | "TextArea"
                | "Number"
                | "Currency"
                | "Percent"
                | "Date"
                | "DateTime"
                | "Time"
                | "Checkbox"
                | "SingleSelect"
                | "MultiSelect";
              allowManualFilter?: boolean;
              fieldTable: string;
              pickList?: {
                formalName?: string;
                value: string | number;
              }[];
            };
            gogovFieldId?: number | string;
          }[];
          externalFields: {
            externalFieldName: string;
            externalFieldId?: string;
            externalRecordType:
              | "LucityWorkRequest"
              | "SimplicityServiceRequest"
              | "AssetEssentialsWorkOrder"
              | "EnergovCodeCase"
              | "CityViewCodeRequest"
              | "EdgesoftWorkOrder"
              | "AccelaRecord"
              | "CityWorksServiceRequest";
            allowedSyncTypes: ("Pull" | "Push" | "OneTimePush")[];
            mappingValues?: {
              externalValue: string;
              formalName?: string;
            }[];
          }[];
          dynamicExternalRecordTypes: string[];
          icon: string;
          features: string;
          requirements: string;
          documentationUrl: string;
          externalFormalName: string;
          gogovFormalName: string;
          mappingValueDefaults: {
            gogov: {
              send: {
                gogovValue: string;
                formalName?: string;
              }[];
              get: {
                gogovValue: string;
                formalName?: string;
              }[];
            };
            external: {
              send: {
                externalValue: string;
                formalName?: string;
              }[];
              get: {
                externalValue: string;
                formalName?: string;
              }[];
            };
          };
          errors: {
            message: string;
            context?: string;
          }[];
          integration: {
            settings:
              | {
                  authType: "Anonymous";
                  id: number;
                  cityId: number;
                  name: string;
                  productType: "CRM" | "CE" | "Notify" | "Permits";
                  integrationType:
                    | "Lucity"
                    | "Simplicity"
                    | "CityView"
                    | "Energov"
                    | "Cartegraph"
                    | "AssetEssentials"
                    | "CityWorks"
                    | "Accela"
                    | "Edgesoft";
                  externalRecordType:
                    | "LucityWorkRequest"
                    | "SimplicityServiceRequest"
                    | "AssetEssentialsWorkOrder"
                    | "EnergovCodeCase"
                    | "CityViewCodeRequest"
                    | "EdgesoftWorkOrder"
                    | "AccelaRecord"
                    | "CityWorksServiceRequest";
                  dynamicExternalRecordType?: string;
                  syncingFrequency:
                    | "Realtime"
                    | "Hourly"
                    | "EveryThreeHours"
                    | "Nightly"
                    | "Weekly"
                    | "Monthly"
                    | "Quarterly"
                    | "Yearly";
                  pollingFrequency: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
                  serverUrl: string;
                  maxRequestsPerMinute?: number;
                  maxRecordsPerRequest?: number;
                  adminContactEmails?: string[];
                  adminNotes?: string;
                  portalUrl?: string;
                  /** @format date-time */
                  syncingWorkerLastRanAt?: string;
                  /** @format date-time */
                  pollingWorkerLastRanAt?: string;
                  webhookHash?: string;
                  syncingWorkerRunning: boolean;
                  pollingWorkerRunning: boolean;
                }
              | {
                  authType: "Authenticated";
                  authUser: string;
                  id: number;
                  cityId: number;
                  name: string;
                  productType: "CRM" | "CE" | "Notify" | "Permits";
                  integrationType:
                    | "Lucity"
                    | "Simplicity"
                    | "CityView"
                    | "Energov"
                    | "Cartegraph"
                    | "AssetEssentials"
                    | "CityWorks"
                    | "Accela"
                    | "Edgesoft";
                  externalRecordType:
                    | "LucityWorkRequest"
                    | "SimplicityServiceRequest"
                    | "AssetEssentialsWorkOrder"
                    | "EnergovCodeCase"
                    | "CityViewCodeRequest"
                    | "EdgesoftWorkOrder"
                    | "AccelaRecord"
                    | "CityWorksServiceRequest";
                  dynamicExternalRecordType?: string;
                  syncingFrequency:
                    | "Realtime"
                    | "Hourly"
                    | "EveryThreeHours"
                    | "Nightly"
                    | "Weekly"
                    | "Monthly"
                    | "Quarterly"
                    | "Yearly";
                  pollingFrequency: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
                  serverUrl: string;
                  maxRequestsPerMinute?: number;
                  maxRecordsPerRequest?: number;
                  adminContactEmails?: string[];
                  adminNotes?: string;
                  portalUrl?: string;
                  /** @format date-time */
                  syncingWorkerLastRanAt?: string;
                  /** @format date-time */
                  pollingWorkerLastRanAt?: string;
                  webhookHash?: string;
                  syncingWorkerRunning: boolean;
                  pollingWorkerRunning: boolean;
                }
              | {
                  authType: "ApiKey";
                  apiKey: string;
                  id: number;
                  cityId: number;
                  name: string;
                  productType: "CRM" | "CE" | "Notify" | "Permits";
                  integrationType:
                    | "Lucity"
                    | "Simplicity"
                    | "CityView"
                    | "Energov"
                    | "Cartegraph"
                    | "AssetEssentials"
                    | "CityWorks"
                    | "Accela"
                    | "Edgesoft";
                  externalRecordType:
                    | "LucityWorkRequest"
                    | "SimplicityServiceRequest"
                    | "AssetEssentialsWorkOrder"
                    | "EnergovCodeCase"
                    | "CityViewCodeRequest"
                    | "EdgesoftWorkOrder"
                    | "AccelaRecord"
                    | "CityWorksServiceRequest";
                  dynamicExternalRecordType?: string;
                  syncingFrequency:
                    | "Realtime"
                    | "Hourly"
                    | "EveryThreeHours"
                    | "Nightly"
                    | "Weekly"
                    | "Monthly"
                    | "Quarterly"
                    | "Yearly";
                  pollingFrequency: "FifteenMinutes" | "ThirtyMinutes" | "Hourly" | "EveryTwoHours" | "EveryThreeHours";
                  serverUrl: string;
                  maxRequestsPerMinute?: number;
                  maxRecordsPerRequest?: number;
                  adminContactEmails?: string[];
                  adminNotes?: string;
                  portalUrl?: string;
                  /** @format date-time */
                  syncingWorkerLastRanAt?: string;
                  /** @format date-time */
                  pollingWorkerLastRanAt?: string;
                  webhookHash?: string;
                  syncingWorkerRunning: boolean;
                  pollingWorkerRunning: boolean;
                };
            mappings: {
              id?: number;
              syncType: "Pull" | "Push" | "OneTimePush";
              gogovFieldName?: string;
              externalFieldName?: string;
              externalFieldId?: string;
              externalRecordType:
                | "LucityWorkRequest"
                | "SimplicityServiceRequest"
                | "AssetEssentialsWorkOrder"
                | "EnergovCodeCase"
                | "CityViewCodeRequest"
                | "EdgesoftWorkOrder"
                | "AccelaRecord"
                | "CityWorksServiceRequest";
              mergeField?: string;
              gogovFieldId?: number;
              mappingValues?: {
                id?: number;
                gogovValue?: string;
                externalValue?: string;
                gogovFieldName?: string;
                externalFieldName?: string;
                externalFieldId?: string;
                gogovFieldId?: number;
              }[];
            }[];
            mainFilterGroup?: {
              id?: number;
              advancedLogic?: string | null;
              filters: (
                | {
                    fieldType: "Text";
                    stringValue: string;
                    condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "TextArea";
                    stringValue: string;
                    condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Number";
                    integerValue: number;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "GreaterThan"
                      | "LessThan"
                      | "GreaterThanOrEqual"
                      | "LessThanOrEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Currency";
                    floatValue: number;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "GreaterThan"
                      | "LessThan"
                      | "GreaterThanOrEqual"
                      | "LessThanOrEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Percent";
                    floatValue: number;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "GreaterThan"
                      | "LessThan"
                      | "GreaterThanOrEqual"
                      | "LessThanOrEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Date";
                    /** @format date-time */
                    dateValue?: string | null;
                    integerValue?: number | null;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "IsBefore"
                      | "IsAfter"
                      | "IsBeforeOrEqual"
                      | "IsAfterOrEqual"
                      | "CurrentDay"
                      | "CurrentWeek"
                      | "CurrentMonth"
                      | "DaysAgo"
                      | "WeeksAgo"
                      | "MonthsAgo"
                      | "YearsAgo"
                      | "DaysAhead"
                      | "WeeksAhead"
                      | "MonthsAhead"
                      | "YearsAhead";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "DateTime";
                    /** @format date-time */
                    dateValue?: string | null;
                    integerValue?: number | null;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "IsBefore"
                      | "IsAfter"
                      | "IsBeforeOrEqual"
                      | "IsAfterOrEqual"
                      | "CurrentDay"
                      | "CurrentWeek"
                      | "CurrentMonth"
                      | "DaysAgo"
                      | "WeeksAgo"
                      | "MonthsAgo"
                      | "YearsAgo"
                      | "DaysAhead"
                      | "WeeksAhead"
                      | "MonthsAhead"
                      | "YearsAhead";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Time";
                    /** @format date-time */
                    dateValue?: string | null;
                    integerValue?: number | null;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "IsBefore"
                      | "IsAfter"
                      | "IsBeforeOrEqual"
                      | "IsAfterOrEqual"
                      | "CurrentDay"
                      | "CurrentWeek"
                      | "CurrentMonth"
                      | "DaysAgo"
                      | "WeeksAgo"
                      | "MonthsAgo"
                      | "YearsAgo"
                      | "DaysAhead"
                      | "WeeksAhead"
                      | "MonthsAhead"
                      | "YearsAhead";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Checkbox";
                    booleanValue: boolean;
                    condition: "Equal" | "NotEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "SingleSelect";
                    jsonValue: (string | number)[];
                    condition: "Any" | "NotAny";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "MultiSelect";
                    jsonValue: any[];
                    condition: "Any" | "NotAny";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
              )[];
            };
            manualFilterGroup?: {
              id?: number;
              advancedLogic?: string | null;
              filters: (
                | {
                    fieldType: "Text";
                    stringValue: string;
                    condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "TextArea";
                    stringValue: string;
                    condition: "Equal" | "NotEqual" | "Contains" | "NotContains" | "StartsWith";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Number";
                    integerValue: number;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "GreaterThan"
                      | "LessThan"
                      | "GreaterThanOrEqual"
                      | "LessThanOrEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Currency";
                    floatValue: number;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "GreaterThan"
                      | "LessThan"
                      | "GreaterThanOrEqual"
                      | "LessThanOrEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Percent";
                    floatValue: number;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "GreaterThan"
                      | "LessThan"
                      | "GreaterThanOrEqual"
                      | "LessThanOrEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Date";
                    /** @format date-time */
                    dateValue?: string | null;
                    integerValue?: number | null;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "IsBefore"
                      | "IsAfter"
                      | "IsBeforeOrEqual"
                      | "IsAfterOrEqual"
                      | "CurrentDay"
                      | "CurrentWeek"
                      | "CurrentMonth"
                      | "DaysAgo"
                      | "WeeksAgo"
                      | "MonthsAgo"
                      | "YearsAgo"
                      | "DaysAhead"
                      | "WeeksAhead"
                      | "MonthsAhead"
                      | "YearsAhead";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "DateTime";
                    /** @format date-time */
                    dateValue?: string | null;
                    integerValue?: number | null;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "IsBefore"
                      | "IsAfter"
                      | "IsBeforeOrEqual"
                      | "IsAfterOrEqual"
                      | "CurrentDay"
                      | "CurrentWeek"
                      | "CurrentMonth"
                      | "DaysAgo"
                      | "WeeksAgo"
                      | "MonthsAgo"
                      | "YearsAgo"
                      | "DaysAhead"
                      | "WeeksAhead"
                      | "MonthsAhead"
                      | "YearsAhead";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Time";
                    /** @format date-time */
                    dateValue?: string | null;
                    integerValue?: number | null;
                    condition:
                      | "Equal"
                      | "NotEqual"
                      | "IsBefore"
                      | "IsAfter"
                      | "IsBeforeOrEqual"
                      | "IsAfterOrEqual"
                      | "CurrentDay"
                      | "CurrentWeek"
                      | "CurrentMonth"
                      | "DaysAgo"
                      | "WeeksAgo"
                      | "MonthsAgo"
                      | "YearsAgo"
                      | "DaysAhead"
                      | "WeeksAhead"
                      | "MonthsAhead"
                      | "YearsAhead";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "Checkbox";
                    booleanValue: boolean;
                    condition: "Equal" | "NotEqual";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "SingleSelect";
                    jsonValue: (string | number)[];
                    condition: "Any" | "NotAny";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
                | {
                    fieldType: "MultiSelect";
                    jsonValue: any[];
                    condition: "Any" | "NotAny";
                    id?: number;
                    order: number;
                    field: string;
                    fieldId?: number | null;
                    fieldTable?: string | null;
                  }
              )[];
            };
            childRecordSettings: {
              id: number;
              cityId: number;
              integrationId: number;
              childRecordType: "Comment" | "Attachment" | "Violation" | "Action" | "Address" | "Vehicle";
              /** @default "Off" */
              setting?: "Off" | "Push" | "TwoWay";
            }[];
            enabled: boolean;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get default configurations for a new data sync integration.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncNewList
     * @request GET:/core/integrations/data-sync/new
     * @secure
     */
    integrationsDataSyncNewList: (
      query: {
        productType: "CRM" | "CE" | "Notify" | "Permits";
        integrationType:
          | "Lucity"
          | "Simplicity"
          | "CityView"
          | "Energov"
          | "Cartegraph"
          | "AssetEssentials"
          | "CityWorks"
          | "Accela"
          | "Edgesoft";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          gogovCapabilities?: {
            Comment: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Attachment: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Violation: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Action: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Address: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
            Vehicle: {
              default: "Off" | "Push" | "TwoWay";
              canOverride: boolean;
              allowedValues?: ("Off" | "Push" | "TwoWay")[];
              publicOnly?: boolean;
              formalName?: string;
            };
          };
          externalCapabilities: {
            LucityWorkRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            SimplicityServiceRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            AssetEssentialsWorkOrder: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            EnergovCodeCase: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            CityViewCodeRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            EdgesoftWorkOrder: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            AccelaRecord: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
            CityWorksServiceRequest: {
              maxRequestsPerMinute: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              maxRecordsPerRequest: {
                default: number;
                canOverride: boolean;
                allowedValues?: number[];
              };
              bulkPolling: boolean;
              childRecordCapabilities?: {
                Comment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Attachment: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Violation: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Action: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Address: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
                Vehicle: {
                  default: "Off" | "Push" | "TwoWay";
                  canOverride: boolean;
                  allowedValues?: ("Off" | "Push" | "TwoWay")[];
                  publicOnly?: boolean;
                  formalName?: string;
                };
              };
              authType: {
                default: "Anonymous" | "ApiKey" | "Authenticated";
                canOverride: boolean;
                allowedValues?: ("Anonymous" | "ApiKey" | "Authenticated")[];
              };
              portalUrl?: boolean;
              serverUrl?: {
                preview?: string;
                helpText?: string;
              };
              dynamicExternalRecordType?: boolean;
            };
          };
          gogovFields: {
            formalName: string;
            gogovFieldName: string;
            mappingValues?: {
              gogovValue: string;
              formalName?: string;
            }[];
            allowedSyncTypes: ("Pull" | "Push" | "OneTimePush")[];
            filterOptions?: {
              fieldType:
                | "Text"
                | "TextArea"
                | "Number"
                | "Currency"
                | "Percent"
                | "Date"
                | "DateTime"
                | "Time"
                | "Checkbox"
                | "SingleSelect"
                | "MultiSelect";
              allowManualFilter?: boolean;
              fieldTable: string;
              pickList?: {
                formalName?: string;
                value: string | number;
              }[];
            };
            gogovFieldId?: number | string;
          }[];
          externalFields: {
            externalFieldName: string;
            externalFieldId?: string;
            externalRecordType:
              | "LucityWorkRequest"
              | "SimplicityServiceRequest"
              | "AssetEssentialsWorkOrder"
              | "EnergovCodeCase"
              | "CityViewCodeRequest"
              | "EdgesoftWorkOrder"
              | "AccelaRecord"
              | "CityWorksServiceRequest";
            allowedSyncTypes: ("Pull" | "Push" | "OneTimePush")[];
            mappingValues?: {
              externalValue: string;
              formalName?: string;
            }[];
          }[];
          dynamicExternalRecordTypes: string[];
          icon: string;
          features: string;
          requirements: string;
          documentationUrl: string;
          externalFormalName: string;
          gogovFormalName: string;
          mappingValueDefaults: {
            gogov: {
              send: {
                gogovValue: string;
                formalName?: string;
              }[];
              get: {
                gogovValue: string;
                formalName?: string;
              }[];
            };
            external: {
              send: {
                externalValue: string;
                formalName?: string;
              }[];
              get: {
                externalValue: string;
                formalName?: string;
              }[];
            };
          };
          errors: {
            message: string;
            context?: string;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/new`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Find code enforcement cases for this location.
     *
     * @tags Locations
     * @name LocationsCodeEnforcementCasesDetail
     * @request GET:/core/locations/{id}/code-enforcement-cases
     * @secure
     */
    locationsCodeEnforcementCasesDetail: (
      id: number,
      query?: {
        status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          cases: {
            id: number;
            caseNumber: string;
            topic: string;
            assignedTo: string;
            fees: string;
            entered: string;
            lastAction: string;
            openViolations: string[];
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/locations/${id}/code-enforcement-cases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Find associations for this location
     *
     * @tags Locations
     * @name LocationsHistoryDetail
     * @request GET:/core/locations/{id}/history
     * @secure
     */
    locationsHistoryDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          history: {
            key: string;
            type: "Permit" | "CodeCase" | "Inspection";
            id: string | null;
            subType: string | null;
            status: string | null;
            /** @format date-time */
            submitted: string | null;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/locations/${id}/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a location by id
     *
     * @tags Locations
     * @name LocationsDeactivatedUpdate
     * @request PUT:/core/locations/{id}/deactivated
     * @secure
     */
    locationsDeactivatedUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          parcelNumber: string;
          locationAddressId: number | null;
          locationName: string | null;
          ownerName: string | null;
          ownerAddressId: number | null;
          ownerEmail: string | null;
          ownerPhone: string | null;
          lotSize: number | null;
          zoning: string | null;
          yearBuilt: number | null;
          buildingTypeId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
          externalId: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/locations/${id}/deactivated`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a location by id
     *
     * @tags Locations
     * @name LocationsDeactivatedDelete
     * @request DELETE:/core/locations/{id}/deactivated
     * @secure
     */
    locationsDeactivatedDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          parcelNumber: string;
          locationAddressId: number | null;
          locationName: string | null;
          ownerName: string | null;
          ownerAddressId: number | null;
          ownerEmail: string | null;
          ownerPhone: string | null;
          lotSize: number | null;
          zoning: string | null;
          yearBuilt: number | null;
          buildingTypeId: number | null;
          /** @format date-time */
          deactivatedAt: string | null;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          rowTimestamp: string;
          externalId: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/locations/${id}/deactivated`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsCustomFieldsDefaultsCreate
     * @request POST:/core/locations/custom-fields/defaults
     * @secure
     */
    locationsCustomFieldsDefaultsCreate: (params: RequestParams = {}) =>
      this.request<
        {
          recordsCreated: number;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/locations/custom-fields/defaults`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes an email off the suppression list (if the email is on the list)
     *
     * @tags Mail
     * @name MailSuppressionListDeleteCreate
     * @request POST:/core/mail/suppression-list/delete
     * @secure
     */
    mailSuppressionListDeleteCreate: (
      data: {
        /** @pattern ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$ */
        emailAddress: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          message: string;
        }
      >({
        path: `/core/mail/suppression-list/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Gets the an email off the suppression list (if the email is on the list)
     *
     * @tags Mail
     * @name MailSuppressionListQueryCreate
     * @request POST:/core/mail/suppression-list/query
     * @secure
     */
    mailSuppressionListQueryCreate: (
      data: {
        /** @pattern ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$ */
        emailAddress: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          emailAddress: string;
          /** @format date-time */
          lastUpdateTime: string;
          reason: string;
        },
        {
          message: string;
        }
      >({
        path: `/core/mail/suppression-list/query`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notify
     * @name NotifySettingsPublicList
     * @request GET:/core/notify/settings/public
     */
    notifySettingsPublicList: (params: RequestParams = {}) =>
      this.request<
        {
          sitePhoneNumber: string;
        },
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/notify/settings/public`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Send a notification to an anonymous contact via SMS
     *
     * @tags Notify
     * @name NotifySmsNotificationCreate
     * @request POST:/core/notify/sms/notification
     * @secure
     */
    notifySmsNotificationCreate: (
      data: {
        body: string;
        anonymousContactId: number;
        notificationsCMSId: number;
        notificationsMassNotificationId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/notify/sms/notification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all subscription groups
     *
     * @tags Notify
     * @name NotifySubscriberContactMethodSearchList
     * @request GET:/core/notify/subscriber-contact-method/search
     * @secure
     */
    notifySubscriberContactMethodSearchList: (
      query?: {
        cursor?: number;
        /**
         * @min 1
         * @exclusiveMin true
         * @max 500
         * @default 10
         */
        take?: number;
        query?: string;
        subscriptionGroupIds?: string;
        types?: string;
        status?: string;
        /** @default "createdAt:desc" */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          data: {
            id: number;
            cityId: number;
            type: "Email" | "Phone" | "App";
            origin: "WebPortal" | "StaffSoftware" | "Import" | "InboundSMS" | "InboundVoice";
            invitedMethod: "SMS" | "Voice" | "Email" | "Manual" | null;
            optedInMethod: "SMS" | "Voice" | "Email" | "Manual" | null;
            optedOutMethod: "SMS" | "Voice" | "Email" | "Manual" | null;
            verifiedMethod: "SMS" | "Voice" | "Email" | "Manual" | null;
            status: "OptedOut" | "Enrolled" | "Invited" | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            identifier: string;
            isPhoneNumberSMSCapable: boolean | null;
            /** @format date-time */
            invitedAt: string | null;
            /** @format date-time */
            optedInAt: string | null;
            /** @format date-time */
            optedOutAt: string | null;
            /** @format date-time */
            verifiedAt: string | null;
            person: {
              personId: number;
              firstName: string | null;
              lastName: string | null;
            };
            potentialPersonMatches: {
              personId: number;
              firstName: string | null;
              lastName: string | null;
            }[];
            subscriptionGroups: {
              id: number;
              cityId: number;
              name: string;
            }[];
            hasNoSubscriptionGroupPreferences: boolean;
            /** @format date-time */
            lastCommunicationAttemptedAt: string | null;
          }[];
          aggregations: {
            typeCounts: {
              Email: number;
              Phone: number;
              App: number;
            };
            totalTypeCount: number;
          };
        },
        any
      >({
        path: `/core/notify/subscriber-contact-method/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a subscription group
     *
     * @tags Notify
     * @name NotifySubscriptionGroupDetail
     * @request GET:/core/notify/subscription-group/{id}
     * @secure
     */
    notifySubscriptionGroupDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          autoSubscribe: boolean;
          visibility: "Public" | "Unlisted" | "Private";
          description: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/notify/subscription-group/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a subscription group
     *
     * @tags Notify
     * @name NotifySubscriptionGroupUpdate
     * @request PUT:/core/notify/subscription-group/{id}
     * @secure
     */
    notifySubscriptionGroupUpdate: (
      id: number,
      data: {
        /** @maxLength 191 */
        name: string;
        autoSubscribe: boolean;
        visibility: "Public" | "Unlisted" | "Private";
        /** @maxLength 191 */
        description: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          autoSubscribe: boolean;
          visibility: "Public" | "Unlisted" | "Private";
          description: string | null;
        },
        any
      >({
        path: `/core/notify/subscription-group/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send a notification to an anonymous contact via Voice
     *
     * @tags Notify
     * @name NotifyVoiceNotificationCreate
     * @request POST:/core/notify/voice/notification
     * @secure
     */
    notifyVoiceNotificationCreate: (
      data: {
        anonymousContactId: number;
        notificationsCMSId: number;
        notificationsMassNotificationId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            message: string;
          }
      >({
        path: `/core/notify/voice/notification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a sales detail report for the city.
     *
     * @tags Reports
     * @name PermitsReportFeesCreate
     * @request POST:/core/permits/report/fees/
     * @secure
     */
    permitsReportFeesCreate: (
      data: {
        issued_at?: {
          from?: string | null;
          to?: string | null;
        };
        permit_type?: number[] | null;
        group_by?: "fee_item" | "confirmation_number" | "permit_type" | "general_ledger" | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          grandTotal: string;
          reportData: {
            groupName: string;
            total: string;
            data: {
              issued_at: string;
              permit_type: string;
              confirmation_number?: string | null;
              fee_item: string;
              general_ledger: string;
              applicant?: string | null;
              submitter?: string | null;
              submitted_at?: string | null;
              paid: "Paid" | "Unpaid" | "Partial" | "Over";
              amount: string;
            }[];
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/permits/report/fees/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a transaction report for the city.
     *
     * @tags Reports
     * @name PermitsReportTransactionsCreate
     * @request POST:/core/permits/report/transactions/
     * @secure
     */
    permitsReportTransactionsCreate: (
      data: {
        created_at?: {
          from?: string | null;
          to?: string | null;
          dateOption?: string | null;
        };
        type?: string[] | null;
        permit_type?: number[] | null;
        cash_register?: number[] | null;
        method?: string[] | null;
        entered_by?: string[] | null;
        group_by?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          grandTotal: string;
          subTotals: Record<
            string,
            {
              total: string;
              count: number;
            }
          >;
          reportData: {
            groupName: string;
            total: string;
            subTotals: Record<
              string,
              {
                total: string;
                count: number;
              }
            >;
            data: {
              created_at: string;
              type?: string | null;
              permit_type?: string | null;
              confirmation_number?: string | null;
              applicant?: string | null;
              issued_at?: string | null;
              note?: string | null;
              entered_by?: string | null;
              cash_register?: string | null;
              method?: string | null;
              amount: string;
            }[];
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/permits/report/transactions/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Webhook to trigger a data sync integration to pull data from an external source
     *
     * @tags Integrations
     * @name WebhooksDataSyncCreate
     * @request POST:/core/webhooks/data-sync/{hash}
     */
    webhooksDataSyncCreate: (
      hash: string,
      query: {
        ids: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
          errors?: Record<string, string>;
        },
        | (
            | {
                statusCode: number;
                error: string;
                message: string;
              }
            | {
                statusCode: 400;
                error: "Bad Request";
                message: string;
              }
            | ({
                statusCode: number;
                error: string;
                message: string;
              } & {
                errors?: Record<string, string>;
              })
          )
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/webhooks/data-sync/${hash}`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a billing transaction in the specified account
     *
     * @tags Billing
     * @name BillingAccountsTransactionsCreate
     * @request POST:/core/billing/accounts/{accountId}/transactions
     * @secure
     */
    billingAccountsTransactionsCreate: (
      accountId: number,
      data: {
        serviceItem?: "SmsMessage" | "VoiceMinute" | "VoiceAlaskaMinute" | "MassNotification" | null;
        status: "Pending" | "Cleared" | "Canceled";
        type: "Payment" | "Charge" | "Refund" | "Adjustment";
        description: string;
        /** @format date-time */
        transactionDate: string;
        /** @format date-time */
        serviceDate?: string | null;
        amount?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        quantity?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        rate?: number | null;
        referenceNumber?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          serviceItem: "SmsMessage" | "VoiceMinute" | "VoiceAlaskaMinute" | "MassNotification" | null;
          amount: number;
          status: "Pending" | "Cleared" | "Canceled";
          type: "Payment" | "Charge" | "Refund" | "Adjustment";
          description: string;
          transactionDate: string;
          serviceDate: string;
          quantity: number;
          rate: number;
          referenceNumber: string | null;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/billing/accounts/${accountId}/transactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all billing transactions for the specified account
     *
     * @tags Billing
     * @name BillingAccountsTransactionsDetail
     * @request GET:/core/billing/accounts/{accountId}/transactions
     * @secure
     */
    billingAccountsTransactionsDetail: (
      accountId: number,
      query: {
        cursor?: number;
        /**
         * @min 1
         * @exclusiveMin true
         * @max 500
         */
        take: number;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          serviceItem: "SmsMessage" | "VoiceMinute" | "VoiceAlaskaMinute" | "MassNotification" | null;
          amount: number;
          status: "Pending" | "Cleared" | "Canceled";
          type: "Payment" | "Charge" | "Refund" | "Adjustment";
          description: string;
          transactionDate: string;
          serviceDate: string;
          quantity: number;
          rate: number;
          referenceNumber: string | null;
        }[],
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/billing/accounts/${accountId}/transactions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get values for CE fields that can be mapped to location fields.
     *
     * @tags CE
     * @name CeGeneralSettingsLocationMappingStandardCeFieldsList
     * @request GET:/core/ce/general-settings/location-mapping/standard-ce-fields
     * @secure
     */
    ceGeneralSettingsLocationMappingStandardCeFieldsList: (params: RequestParams = {}) =>
      this.request<
        {
          fields: (
            | "PropertyAlert"
            | "PropertyOccupant"
            | "PropertyPhone"
            | "PropertyCell"
            | "PropertyEmail"
            | "EnforceZone"
            | "PropertyStatus"
            | "Subdivision"
            | "Classification"
            | "SubClassification"
            | "Flag1"
            | "Flag2"
            | "Flag3"
            | "Flag4"
          )[];
        },
        any
      >({
        path: `/core/ce/general-settings/location-mapping/standard-ce-fields`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Queue after-update job for CE case
     *
     * @tags CE
     * @name CeHookAfterUpdateUpdate
     * @request PUT:/core/ce/hook/after-update/{id}
     * @secure
     */
    ceHookAfterUpdateUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/ce/hook/after-update/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Re-index a CE record by ID
     *
     * @tags CE
     * @name CeSearchIndexUpdate
     * @request PUT:/core/ce/search/index/{id}
     * @secure
     */
    ceSearchIndexUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/ce/search/index/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Queue after-update job for CRM case
     *
     * @tags CRM
     * @name CrmHookAfterUpdateUpdate
     * @request PUT:/core/crm/hook/after-update/{id}
     * @secure
     */
    crmHookAfterUpdateUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/crm/hook/after-update/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Re-index a CRM record by ID
     *
     * @tags CRM
     * @name CrmSearchIndexUpdate
     * @request PUT:/core/crm/search/index/{id}
     * @secure
     */
    crmSearchIndexUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/crm/search/index/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deactivate a document template by id
     *
     * @tags Documents
     * @name DocumentsTemplatesDeactivatedDelete
     * @request DELETE:/core/documents/templates/{id}/deactivated
     * @secure
     */
    documentsTemplatesDeactivatedDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          resourceType: "Permits";
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          description: string | null;
          s3Url: string | null;
          isPublic: boolean | null;
          manyDocumentSubTypes?: {
            id: number;
            documentsTemplateId: number;
            permitsTypeId: number;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/templates/${id}/deactivated`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reactivate a document template by id
     *
     * @tags Documents
     * @name DocumentsTemplatesDeactivatedUpdate
     * @request PUT:/core/documents/templates/{id}/deactivated
     * @secure
     */
    documentsTemplatesDeactivatedUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          resourceType: "Permits";
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          description: string | null;
          s3Url: string | null;
          isPublic: boolean | null;
          manyDocumentSubTypes?: {
            id: number;
            documentsTemplateId: number;
            permitsTypeId: number;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/templates/${id}/deactivated`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Download a document template by id
     *
     * @tags Documents
     * @name DocumentsTemplatesDownloadDetail
     * @request GET:/core/documents/templates/{id}/download
     * @secure
     */
    documentsTemplatesDownloadDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          signedUrl: string;
          fileName: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/documents/templates/${id}/download`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a thumbnail for a file
     *
     * @tags Thumbnails
     * @name FileThumbnailDetail
     * @request GET:/core/file/{id}/thumbnail/{size}
     * @secure
     */
    fileThumbnailDetail: (id: string, size: "small" | "medium", params: RequestParams = {}) =>
      this.request<
        {
          url: string | null;
          fileType: string | null;
          data: {
            sourceFileId: string;
            fileId: string | null;
            id: number;
            heightPx: number;
            widthPx: number;
            status: "Pending" | "Running" | "Complete" | "Error";
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/file/${id}/thumbnail/${size}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates file metadata and finishes a multipart file upload
     *
     * @tags File Upload
     * @name FileMultipartFinalizedCreate
     * @request POST:/core/file/multipart/{id}/finalized
     * @secure
     */
    fileMultipartFinalizedCreate: (
      id: string,
      data: {
        uploadId: string;
        parts: {
          partNumber: number;
          eTag: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: string;
          file: {
            id: number;
            cityId: number;
            uuid: string;
            usage:
              | "Permits"
              | "CE"
              | "CRM"
              | "InspectionItemCommentAttachments"
              | "InspectionAttachmentVideoOriginal"
              | "SiteAssets"
              | "NotifyVoiceResources";
            s3Key: string;
            bucket: string;
            s3StorageClass: string | null;
            status: "New" | "Temp" | "Committed" | "Archived";
            sizeInBytes: number | null;
            originalFileName: string;
            fileExtension: string;
            /** @format date-time */
            fileUpdatedAt: string | null;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @format date-time */
            deleteRequestedAt: string | null;
            /** @format date-time */
            deletedAt: string | null;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/file/multipart/${id}/finalized`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Rejects the request associated with an inspection
     *
     * @tags Inspections
     * @name InspectionsRequestRejectUpdate
     * @request PUT:/core/inspections/{id}/request/reject
     * @secure
     */
    inspectionsRequestRejectUpdate: (
      id: number,
      data: {
        data: {
          message: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/request/reject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the scheduler time slot options for inspections
     *
     * @tags Inspections
     * @name InspectionsTimeSlotOptionsDetail
     * @request GET:/core/inspections/{id}/time-slot/options
     * @secure
     */
    inspectionsTimeSlotOptionsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            value: string | null;
            label: string;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/time-slot/options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an inspections on-site contact info by id
     *
     * @tags Inspections
     * @name InspectionsPublicOnSiteContactInfoUpdate
     * @request PUT:/core/inspections/public/{id}/on-site-contact-info
     * @secure
     */
    inspectionsPublicOnSiteContactInfoUpdate: (
      id: number,
      data: {
        onSiteContactName?: string;
        onSiteContactPhone?: string;
        onSiteContactApplicantInstructions?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              status: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              comment: string | null;
              applicant?: any;
              assignee?: any;
              "record-id": number | null;
              inspectable_type: string | null;
              inspectable_id: number;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              onSiteContactApplicantInstructions?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              reInspection: {
                id: number;
                status: string;
              } | null;
              previousInspectionId?: number | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/public/${id}/on-site-contact-info`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all previous inspections for a given re-inspection
     *
     * @tags Inspections
     * @name InspectionsPublicPreviousInspectionsDetail
     * @request GET:/core/inspections/public/{id}/previous-inspections
     * @secure
     */
    inspectionsPublicPreviousInspectionsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection";
            attributes: {
              title: string;
              status: string | null;
              /** @format date-time */
              "scheduled-at": string | null;
              "scheduled-date": string | null;
              "scheduled-time": string | null;
              "scheduled-meridiem": string | null;
              comment: string | null;
              applicant?: any;
              assignee?: any;
              "record-id": number | null;
              inspectable_type: string | null;
              inspectable_id: number;
              address: {
                id?: number;
                attn: string | null;
                address: string;
                address2: string | null;
                city: string;
                state: string;
                zip: string;
                /** @format date-time */
                rowTimestamp: string;
                countryId: string;
              };
              primaryLocationId: number | null;
              sections: {
                data: {
                  id: string;
                  type: "inspection-section";
                  attributes: {
                    title: string;
                    "inspections-types-sections-id": number;
                    order: number | null;
                    /** @format date-time */
                    "created-at": string;
                    /** @format date-time */
                    "updated-at": string;
                    "inspection-id": number;
                    items: {
                      data: {
                        id: string;
                        type: "inspection-item";
                        attributes: {
                          title: string;
                          "inspections-types-items-id": number;
                          status: string | null;
                          type: string | null;
                          order: number | null;
                          "inspection-section-id": number;
                          /** @format date-time */
                          "created-at": string;
                          /** @format date-time */
                          "updated-at": string;
                          "previous-item-status": "passed" | "failed" | null;
                        };
                      };
                    }[];
                  };
                };
              }[];
              onSiteContactApplicantInstructions?: string | null;
              onSiteContactName?: string | null;
              onSiteContactPhone?: string | null;
              /** @format date-time */
              startedAt?: string | null;
              /** @format date-time */
              completedAt?: string | null;
              request: {
                /** @format date-time */
                rejectedAt: string | null;
                rejectionMessage: string | null;
                message: string | null;
                preferences: {
                  /** @format date-time */
                  date: string | null;
                  meridiem: "AM" | "PM" | null;
                }[];
              };
              citizenHelpText: string;
              blockOutDays: {
                key: string;
                dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
                meridiem: "AM" | "PM" | null;
              }[];
              permit?: {
                id: number;
                cityId: number;
                confirmationNumber?: string | null;
                reservationNumber?: string | null;
                permitsType?: {
                  name?: string | null;
                };
              };
              reInspection: {
                id: number;
                status: string;
              } | null;
              previousInspectionId?: number | null;
            };
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/public/${id}/previous-inspections`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the citizen request associated with an inspection.
     *
     * @tags Inspections
     * @name InspectionsPublicRequestUpdate
     * @request PUT:/core/inspections/public/{id}/request
     * @secure
     */
    inspectionsPublicRequestUpdate: (
      id: number,
      data: {
        data: {
          schedulingPreferencesMessage: string | null;
          schedulingPreferences: {
            /** @format date-time */
            preferredDate: string;
            meridiem?: "AM" | "PM" | null;
          }[];
          onSiteContactName: string | null;
          onSiteContactApplicantInstructions: string | null;
          onSiteContactPhone: string | null;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: string;
          type: "inspection";
          attributes: {
            title: string;
            status: string | null;
            /** @format date-time */
            "scheduled-at": string | null;
            "scheduled-date": string | null;
            "scheduled-time": string | null;
            "scheduled-meridiem": string | null;
            comment: string | null;
            applicant?: any;
            assignee?: any;
            "record-id": number | null;
            inspectable_type: string | null;
            inspectable_id: number;
            address: {
              id?: number;
              attn: string | null;
              address: string;
              address2: string | null;
              city: string;
              state: string;
              zip: string;
              /** @format date-time */
              rowTimestamp: string;
              countryId: string;
            };
            primaryLocationId: number | null;
            sections: {
              data: {
                id: string;
                type: "inspection-section";
                attributes: {
                  title: string;
                  "inspections-types-sections-id": number;
                  order: number | null;
                  /** @format date-time */
                  "created-at": string;
                  /** @format date-time */
                  "updated-at": string;
                  "inspection-id": number;
                  items: {
                    data: {
                      id: string;
                      type: "inspection-item";
                      attributes: {
                        title: string;
                        "inspections-types-items-id": number;
                        status: string | null;
                        type: string | null;
                        order: number | null;
                        "inspection-section-id": number;
                        /** @format date-time */
                        "created-at": string;
                        /** @format date-time */
                        "updated-at": string;
                        "previous-item-status": "passed" | "failed" | null;
                      };
                    };
                  }[];
                };
              };
            }[];
            onSiteContactApplicantInstructions?: string | null;
            onSiteContactName?: string | null;
            onSiteContactPhone?: string | null;
            /** @format date-time */
            startedAt?: string | null;
            /** @format date-time */
            completedAt?: string | null;
            request: {
              /** @format date-time */
              rejectedAt: string | null;
              rejectionMessage: string | null;
              message: string | null;
              preferences: {
                /** @format date-time */
                date: string | null;
                meridiem: "AM" | "PM" | null;
              }[];
            };
            citizenHelpText: string;
            blockOutDays: {
              key: string;
              dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
              meridiem: "AM" | "PM" | null;
            }[];
            permit?: {
              id: number;
              cityId: number;
              confirmationNumber?: string | null;
              reservationNumber?: string | null;
              permitsType?: {
                name?: string | null;
              };
            };
            reInspection: {
              id: number;
              status: string;
            } | null;
            previousInspectionId?: number | null;
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/public/${id}/request`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Re-index an Inspection record by ID
     *
     * @tags Inspections
     * @name InspectionsSearchIndexUpdate
     * @request PUT:/core/inspections/search/index/{id}
     * @secure
     */
    inspectionsSearchIndexUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/search/index/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the schedule associated with an inspection-type
     *
     * @tags Inspections
     * @name InspectionsTypesScheduleDetail
     * @request GET:/core/inspections/types/{id}/schedule
     * @secure
     */
    inspectionsTypesScheduleDetail: (
      id: number,
      query?: {
        /** @format date-time */
        week?: string;
        /** @default 0 */
        window?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          schedule: Record<
            string,
            Record<
              string,
              {
                AM: number;
                PM: number;
              }
            >
          >;
          inspectors: {
            id: number;
            firstName?: string;
            lastName?: string;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types/${id}/schedule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deactivate an inspection-type
     *
     * @tags Inspections
     * @name InspectionsTypesDeactivatedUpdate
     * @request PUT:/core/inspections/types/{id}/deactivated
     * @secure
     */
    inspectionsTypesDeactivatedUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        object,
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types/${id}/deactivated`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reactivate an inspection type
     *
     * @tags Inspections
     * @name InspectionsTypesDeactivatedDelete
     * @request DELETE:/core/inspections/types/{id}/deactivated
     * @secure
     */
    inspectionsTypesDeactivatedDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        object,
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types/${id}/deactivated`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get block-out day options for an inspection-type
     *
     * @tags Inspections
     * @name InspectionsTypesBlockOutDaysOptionsList
     * @request GET:/core/inspections/types/block-out-days/options
     * @secure
     */
    inspectionsTypesBlockOutDaysOptionsList: (params: RequestParams = {}) =>
      this.request<
        {
          data: {
            key: string;
            dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
            meridiem: "AM" | "PM" | null;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/types/block-out-days/options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Checks if a record has been synced to an external system and returns the data sync record if it exists
     *
     * @tags Integrations
     * @name IntegrationsDataSyncDetail2
     * @request GET:/core/integrations/data-sync/{id}/{recordId}
     * @originalName integrationsDataSyncDetail
     * @duplicate
     * @secure
     */
    integrationsDataSyncDetail2: (
      id: number,
      recordId: string | number,
      query?: {
        /** @default false */
        deSynced?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          /** @format date-time */
          lastPushedAt: string | null;
          /** @format date-time */
          lastPulledAt: string | null;
          lastPushError: string | null;
          lastPullError: string | null;
          /** @format date-time */
          gogovRecordUpdatedAt: string | null;
          gogovToExternalHash: string | null;
          externalRecordId: string | null;
          /** @format date-time */
          externalRecordUpdatedAt: string | null;
          externalRecordUrl: string | null;
          externalToGogovHash: string | null;
          gogovRecordType: "CRM" | "CE" | "Notify" | "Permits";
          externalRecordType:
            | "LucityWorkRequest"
            | "SimplicityServiceRequest"
            | "AssetEssentialsWorkOrder"
            | "EnergovCodeCase"
            | "CityViewCodeRequest"
            | "EdgesoftWorkOrder"
            | "AccelaRecord"
            | "CityWorksServiceRequest";
          dataSyncRecordType: "MainRecord" | "Comment" | "Attachment" | "Violation" | "Action" | "Address" | "Vehicle";
          /** @default "" */
          dynamicExternalRecordType?: string;
          /** @format date-time */
          deSyncedAt: string | null;
          /** @format date-time */
          gogovRecordDisabledAt: string | null;
          externalDisplayId: string | null;
          gogovRecordId: string | number;
          portalUrl?: string | null;
          /** @format date-time */
          syncingWorkerLastRanAt?: string | null;
          /** @format date-time */
          pollingWorkerLastRanAt?: string | null;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/${recordId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Either manually de-syncs a record from an integration, or hard deletes a record that has already been de-synced
     *
     * @tags Integrations
     * @name IntegrationsDataSyncDelete2
     * @request DELETE:/core/integrations/data-sync/{id}/{recordId}
     * @originalName integrationsDataSyncDelete
     * @duplicate
     * @secure
     */
    integrationsDataSyncDelete2: (
      id: number,
      recordId: string | number,
      query?: {
        /** @default false */
        hardDelete?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/${recordId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Manually push a record to an external system, creates the data sync record if it doesn't exist, and enqueues a job to push the record to the external system
     *
     * @tags Integrations
     * @name IntegrationsDataSyncCreate2
     * @request POST:/core/integrations/data-sync/{id}/{recordId}
     * @originalName integrationsDataSyncCreate
     * @duplicate
     * @secure
     */
    integrationsDataSyncCreate2: (id: number, recordId: string | number, params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          /** @format date-time */
          lastPushedAt: string | null;
          /** @format date-time */
          lastPulledAt: string | null;
          lastPushError: string | null;
          lastPullError: string | null;
          /** @format date-time */
          gogovRecordUpdatedAt: string | null;
          gogovToExternalHash: string | null;
          externalRecordId: string | null;
          /** @format date-time */
          externalRecordUpdatedAt: string | null;
          externalRecordUrl: string | null;
          externalToGogovHash: string | null;
          gogovRecordType: "CRM" | "CE" | "Notify" | "Permits";
          externalRecordType:
            | "LucityWorkRequest"
            | "SimplicityServiceRequest"
            | "AssetEssentialsWorkOrder"
            | "EnergovCodeCase"
            | "CityViewCodeRequest"
            | "EdgesoftWorkOrder"
            | "AccelaRecord"
            | "CityWorksServiceRequest";
          dataSyncRecordType: "MainRecord" | "Comment" | "Attachment" | "Violation" | "Action" | "Address" | "Vehicle";
          /** @default "" */
          dynamicExternalRecordType?: string;
          /** @format date-time */
          deSyncedAt: string | null;
          /** @format date-time */
          gogovRecordDisabledAt: string | null;
          externalDisplayId: string | null;
          gogovRecordId: string | number;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/${recordId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Enables a data sync integration.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncEnableUpdate
     * @request PUT:/core/integrations/data-sync/{id}/enable
     * @secure
     */
    integrationsDataSyncEnableUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message?: any;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/enable`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Checks a record passed as json against the filters of an integration and returns which filters it matched
     *
     * @tags Integrations
     * @name IntegrationsDataSyncFiltersCreate
     * @request POST:/core/integrations/data-sync/{id}/filters
     * @secure
     */
    integrationsDataSyncFiltersCreate: (
      id: number,
      data: {
        record: (string | number | boolean | "null" | null) | any[] | Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          manualFilters: boolean;
          mainFilters: boolean;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/filters`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Make requests to external system with core service as a proxy.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncProxyCreate
     * @request POST:/core/integrations/data-sync/{id}/proxy
     * @secure
     */
    integrationsDataSyncProxyCreate: (
      id: number,
      data: {
        method: "GET" | "POST" | "PUT" | "PATCH" | "CONNECT" | "DELETE" | "OPTIONS" | "TRACE" | "HEAD";
        params?: (string | number | boolean | "null" | null) | any[] | Record<string, any>;
        data?: (string | number | boolean | "null" | null) | any[] | Record<string, any>;
        url: string;
        /** @default 10000 */
        timeout?: number;
        auth?: {
          username: string;
          password: string;
        };
        httpAgent?: {
          keepAlive?: boolean;
          keepAliveMsecs?: number;
          maxSockets?: number;
          maxFreeSockets?: number;
          timeout?: number;
          freeSocketTimeout?: number;
          scheduling?: "fifo" | "lifo";
          rejectUnauthorized?: boolean;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/proxy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Test the connection of a data sync integration.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncTestCreate
     * @request POST:/core/integrations/data-sync/{id}/test
     * @secure
     */
    integrationsDataSyncTestCreate: (
      id: number,
      data: {
        dynamicExternalRecordType?: string;
        externalRecordType?:
          | "LucityWorkRequest"
          | "SimplicityServiceRequest"
          | "AssetEssentialsWorkOrder"
          | "EnergovCodeCase"
          | "CityViewCodeRequest"
          | "EdgesoftWorkOrder"
          | "AccelaRecord"
          | "CityWorksServiceRequest";
        serverUrl?: string;
        auth?:
          | {
              authType: "Anonymous";
            }
          | {
              authType: "Authenticated";
              authPassword?: string;
              authUser?: string;
            }
          | {
              authType: "ApiKey";
              apiKey?: string;
            };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success: boolean;
          message: string;
          warnings?: string[];
          results?: (string | number | boolean | "null" | null) | any[] | Record<string, any>;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Disables a data sync integration.
     *
     * @tags Integrations
     * @name IntegrationsDataSyncDisableUpdate
     * @request PUT:/core/integrations/data-sync/{id}/disable
     * @secure
     */
    integrationsDataSyncDisableUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message?: any;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/disable`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get function that recives a shortened URL and redirects to the original URL
     *
     * @tags Link Shortener
     * @name LinkShortenerDetail
     * @request GET:/core/link-shortener/{cityId}/{openCode}/{shortCode}
     */
    linkShortenerDetail: (cityId: string, openCode: string, shortCode: string, params: RequestParams = {}) =>
      this.request<
        {
          url?: string;
        },
        | object
        | {
            statusCode: number;
            error: string;
            message: string;
          }
      >({
        path: `/core/link-shortener/${cityId}/${openCode}/${shortCode}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get mass notification send list for sms channel
     *
     * @tags Notify
     * @name NotifyAnonymousContactSmsSendListList
     * @request GET:/core/notify/anonymous-contact/sms/send-list
     * @secure
     */
    notifyAnonymousContactSmsSendListList: (params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          phoneNumber: string;
          /** @format date-time */
          phoneNumberOptedInAt: string | null;
          /** @format date-time */
          phoneNumberOptedOutAt: string | null;
          /** @format date-time */
          phoneNumberInvitedAt: string | null;
        }[],
        | {
            statusCode: number;
            error: string;
            message: string;
            validationErrors: string[];
          }
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
      >({
        path: `/core/notify/anonymous-contact/sms/send-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get mass notification send list for voice channel
     *
     * @tags Notify
     * @name NotifyAnonymousContactVoiceSendListList
     * @request GET:/core/notify/anonymous-contact/voice/send-list
     * @secure
     */
    notifyAnonymousContactVoiceSendListList: (
      query?: {
        /** @default "false" */
        forceVoice?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          phoneNumber: string;
          /** @format date-time */
          phoneNumberOptedInAt: string | null;
          /** @format date-time */
          phoneNumberOptedOutAt: string | null;
          /** @format date-time */
          phoneNumberInvitedAt: string | null;
        }[],
        | {
            statusCode: number;
            error: string;
            message: string;
            validationErrors: string[];
          }
        | {
            statusCode: 400;
            error: "Bad Request";
            message: string;
          }
      >({
        path: `/core/notify/anonymous-contact/voice/send-list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Receives incoming SMS message events coming from Twilio
     *
     * @tags Notify
     * @name NotifyHookSmsIncomingCreate
     * @request POST:/core/notify/hook/sms/incoming
     */
    notifyHookSmsIncomingCreate: (data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/core/notify/hook/sms/incoming`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Receives sms status events coming from Twilio
     *
     * @tags Notify
     * @name NotifyHookSmsStatusCreate
     * @request POST:/core/notify/hook/sms/status
     */
    notifyHookSmsStatusCreate: (data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/core/notify/hook/sms/status`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Receives incoming voice call events coming from Twilio
     *
     * @tags Notify
     * @name NotifyHookVoiceIncomingCreate
     * @request POST:/core/notify/hook/voice/incoming
     */
    notifyHookVoiceIncomingCreate: (data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/core/notify/hook/voice/incoming`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Receives voice status events coming from Twilio
     *
     * @tags Notify
     * @name NotifyHookVoiceStatusCreate
     * @request POST:/core/notify/hook/voice/status
     */
    notifyHookVoiceStatusCreate: (data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/core/notify/hook/voice/status`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get sms notification info (send list count, estimated cost, etc.)
     *
     * @tags Notify
     * @name NotifySmsNotificationInfoList
     * @request GET:/core/notify/sms/notification/info
     * @secure
     */
    notifySmsNotificationInfoList: (params: RequestParams = {}) =>
      this.request<
        {
          smsSendListCount: number;
          totalCredits: number;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/notify/sms/notification/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deactivate a subscription group
     *
     * @tags Notify
     * @name NotifySubscriptionGroupDeactivatedUpdate
     * @request PUT:/core/notify/subscription-group/{id}/deactivated
     * @secure
     */
    notifySubscriptionGroupDeactivatedUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          autoSubscribe: boolean;
          visibility: "Public" | "Unlisted" | "Private";
          description: string | null;
        },
        any
      >({
        path: `/core/notify/subscription-group/${id}/deactivated`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reactivate a subscription group
     *
     * @tags Notify
     * @name NotifySubscriptionGroupDeactivatedDelete
     * @request DELETE:/core/notify/subscription-group/{id}/deactivated
     * @secure
     */
    notifySubscriptionGroupDeactivatedDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          /** @format date-time */
          deactivatedAt: string | null;
          name: string;
          autoSubscribe: boolean;
          visibility: "Public" | "Unlisted" | "Private";
          description: string | null;
        },
        any
      >({
        path: `/core/notify/subscription-group/${id}/deactivated`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all notify incoming call IVR audio resources
     *
     * @tags Notify
     * @name NotifyVoiceAudioResourcePreGeneratedList
     * @request GET:/core/notify/voice/audio-resource/pre-generated
     * @secure
     */
    notifyVoiceAudioResourcePreGeneratedList: (params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          key: string;
          fileDurationInMilliseconds: number;
          s3File: {
            id: number;
            uuid: string;
          };
          fileUrl: string;
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/notify/voice/audio-resource/pre-generated`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a voice audio resource file for a mass notification
     *
     * @tags Notify
     * @name NotifyVoiceNotificationGenerateCreate
     * @request POST:/core/notify/voice/notification/generate
     * @secure
     */
    notifyVoiceNotificationGenerateCreate: (
      data: {
        voiceContent: string;
        isPreview?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: string;
          transcript: string;
          voiceAudioResourceId: number;
          voiceAudioResourceFileDurationInMilliseconds: number;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/notify/voice/notification/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get voice notification info (send list count, estimated cost, etc.)
     *
     * @tags Notify
     * @name NotifyVoiceNotificationInfoList
     * @request GET:/core/notify/voice/notification/info
     * @secure
     */
    notifyVoiceNotificationInfoList: (
      query: {
        /** @default "false" */
        forceVoice?: "true" | "false";
        characterCount: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          voiceSendListCount: number;
          totalCredits: number;
        },
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/notify/voice/notification/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Re-index a Payout record by ID
     *
     * @tags Payouts
     * @name PayoutsSearchIndexUpdate
     * @request PUT:/core/payouts/search/index/{id}
     * @secure
     */
    payoutsSearchIndexUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/payouts/search/index/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permits
     * @name PermitsSearchIndexUpdate
     * @request PUT:/core/permits/search/index/{id}
     * @secure
     */
    permitsSearchIndexUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/permits/search/index/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Re-index a Person record by ID
     *
     * @tags Person
     * @name PersonsSearchIndexUpdate
     * @request PUT:/core/persons/search/index/{id}
     * @secure
     */
    personsSearchIndexUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/persons/search/index/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsSearchIndexUpdate
     * @request PUT:/core/transactions/search/index/{id}
     * @secure
     */
    transactionsSearchIndexUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/transactions/search/index/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsSearchIndexBulkUpdate
     * @request PUT:/core/transactions/search/index/bulk
     * @secure
     */
    transactionsSearchIndexBulkUpdate: (
      data: {
        ids: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/transactions/search/index/bulk`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a webhook hash for the integration
     *
     * @tags Integrations
     * @name WebhooksDataSyncGenerateUpdate
     * @request PUT:/core/webhooks/data-sync/{id}/generate
     * @secure
     */
    webhooksDataSyncGenerateUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          hash: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/webhooks/data-sync/${id}/generate`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Checks a record against the filters of an integration and returns which filters it matched
     *
     * @tags Integrations
     * @name IntegrationsDataSyncFiltersDetail
     * @request GET:/core/integrations/data-sync/{id}/{recordId}/filters
     * @secure
     */
    integrationsDataSyncFiltersDetail: (id: number, recordId: string | number, params: RequestParams = {}) =>
      this.request<
        {
          manualFilters: boolean;
          mainFilters: boolean;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/${recordId}/filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pull data from an external source for a data sync record
     *
     * @tags Integrations
     * @name IntegrationsDataSyncPullDetail
     * @request GET:/core/integrations/data-sync/{id}/{recordId}/pull
     */
    integrationsDataSyncPullDetail: (id: number, recordId: string | number, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/integrations/data-sync/${id}/${recordId}/pull`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate all notify incoming call IVR audio resources
     *
     * @tags Notify
     * @name NotifyVoiceAudioResourcePreGeneratedGenerateUpdate
     * @request PUT:/core/notify/voice/audio-resource/pre-generated/generate
     * @secure
     */
    notifyVoiceAudioResourcePreGeneratedGenerateUpdate: (params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          cityId: number;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          key: string;
          fileDurationInMilliseconds: number;
          s3File: {
            id: number;
            uuid: string;
          };
          fileUrl: string;
        }[],
        {
          statusCode: 400;
          error: "Bad Request";
          message: string;
        }
      >({
        path: `/core/notify/voice/audio-resource/pre-generated/generate`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Receives incoming voice calls from Twilio. IVR menu for managing subscription. 1 to opt-in, 9 to opt-out
     *
     * @tags Notify
     * @name NotifyHookVoiceIncomingIvrManageSubscriptionCreate
     * @request POST:/core/notify/hook/voice/incoming/ivr/manage-subscription
     */
    notifyHookVoiceIncomingIvrManageSubscriptionCreate: (
      data: {
        Digits: number;
        To: string;
        From: string;
        Direction: "inbound" | "outbound-api" | "outbound-dial";
        AccountSid: string;
        [key: string]: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/core/notify/hook/voice/incoming/ivr/manage-subscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Add a comment to an inspection-item
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsCommentCreate
     * @request POST:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment
     * @secure
     */
    inspectionsSectionsItemsCommentCreate: (
      id: number,
      sectionId: number,
      itemId: number,
      data: {
        data?: {
          attributes: {
            comment?: string | null;
            attachments?: string[] | null;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: number;
            user_id: number;
            inspection_item_id: number;
            comment: string | null;
            /** @format date-time */
            created_at: string;
            /** @format date-time */
            updated_at: string;
            /** @format date-time */
            deleted_at: string | null;
            attachment_ids?: {
              id: string;
              url: string | null;
              fileType: string;
              thumbnails?: {
                small: string | null;
                medium: string | null;
              };
            }[];
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all comments on an inspection item
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsCommentDetail
     * @request GET:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment
     * @secure
     */
    inspectionsSectionsItemsCommentDetail: (
      id: number,
      sectionId: number,
      itemId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: number;
            user_id: number;
            inspection_item_id: number;
            comment: string | null;
            /** @format date-time */
            created_at: string;
            /** @format date-time */
            updated_at: string;
            /** @format date-time */
            deleted_at: string | null;
            attachment_ids?: {
              id: string;
              url: string | null;
              fileType: string;
              thumbnails?: {
                small: string | null;
                medium: string | null;
              };
            }[];
            firstName: string | null;
            lastName: string | null;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Fail an inspection-item by id
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsFailCreate
     * @request POST:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/fail
     * @secure
     */
    inspectionsSectionsItemsFailCreate: (
      id: number,
      sectionId: number,
      itemId: number,
      data: object,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection-item";
            attributes: {
              title: string;
              "inspections-types-items-id": number;
              status: string | null;
              type: string | null;
              order: number | null;
              "inspection-section-id": number;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              "previous-item-status": "passed" | "failed" | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/fail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Pass an inspection-item by id
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsPassCreate
     * @request POST:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/pass
     * @secure
     */
    inspectionsSectionsItemsPassCreate: (
      id: number,
      sectionId: number,
      itemId: number,
      data: object,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection-item";
            attributes: {
              title: string;
              "inspections-types-items-id": number;
              status: string | null;
              type: string | null;
              order: number | null;
              "inspection-section-id": number;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              "previous-item-status": "passed" | "failed" | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/pass`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all previous comments for an inspection item
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsPreviousCommentsDetail
     * @request GET:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/previous-comments
     * @secure
     */
    inspectionsSectionsItemsPreviousCommentsDetail: (
      id: number,
      sectionId: number,
      itemId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: number;
            user_id: number;
            inspection_item_id: number;
            comment: string | null;
            /** @format date-time */
            created_at: string;
            /** @format date-time */
            updated_at: string;
            /** @format date-time */
            deleted_at: string | null;
            attachment_ids?: {
              id: string;
              url: string | null;
              fileType: string;
              thumbnails?: {
                small: string | null;
                medium: string | null;
              };
            }[];
            firstName: string | null;
            lastName: string | null;
          }[];
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/previous-comments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Clear an inspection-items status by id
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsStatusDelete
     * @request DELETE:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/status
     * @secure
     */
    inspectionsSectionsItemsStatusDelete: (id: number, sectionId: number, itemId: number, params: RequestParams = {}) =>
      this.request<
        {
          data: {
            id: string;
            type: "inspection-item";
            attributes: {
              title: string;
              "inspections-types-items-id": number;
              status: string | null;
              type: string | null;
              order: number | null;
              "inspection-section-id": number;
              /** @format date-time */
              "created-at": string;
              /** @format date-time */
              "updated-at": string;
              "previous-item-status": "passed" | "failed" | null;
            };
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/status`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a comment on an inspection-item
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsCommentUpdate
     * @request PUT:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment/{commentId}
     * @secure
     */
    inspectionsSectionsItemsCommentUpdate: (
      id: number,
      sectionId: number,
      itemId: number,
      commentId: number,
      data: {
        data?: {
          attributes: {
            comment?: string | null;
            attachments?: string[] | null;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: {
            id: number;
            user_id: number;
            inspection_item_id: number;
            comment: string | null;
            /** @format date-time */
            created_at: string;
            /** @format date-time */
            updated_at: string;
            /** @format date-time */
            deleted_at: string | null;
            attachment_ids?: {
              id: string;
              url: string | null;
              fileType: string;
              thumbnails?: {
                small: string | null;
                medium: string | null;
              };
            }[];
          };
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment/${commentId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a comment on an inspection-item
     *
     * @tags Inspections
     * @name InspectionsSectionsItemsCommentDelete
     * @request DELETE:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment/{commentId}
     * @secure
     */
    inspectionsSectionsItemsCommentDelete: (
      id: number,
      sectionId: number,
      itemId: number,
      commentId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          statusCode: number;
          error: string;
          message: string;
        }
      >({
        path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment/${commentId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
